<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import exportFromJSON from "export-from-json";
import DropZone from "@/components/widgets/dropZone.vue";
import {getBaseUrl} from "@/helpers/baseUrl";
import PageActionBar from "@/components/page-action-bar.vue";


export default {
  page: {
    title: "Compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {DropZone, Layout, PageHeader, Loader, Multiselect, PageActionBar},
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

    };
    return { dropzoneFile, drop, selectedFile, v$: useVuelidate() };
  },
  data() {
    return {
      showModalRota: false,


      numeroDeIteracoes: 0,
      totalSelecionado: 0,

      listaImpressaoMiniDanfe: [],
      totalCorreioServ: 0,

      showModalEnderEntrega: false,
      clienteData: {},
      loadingCliente: false,
      submittedEnderEntrega: false,
      dtListPesqCidade: null,

      showModalConsCEP: null,
      loadingDadosCep: null,
      consCnpjEndereco: '',
      consCnpjCompl: '',
      consCnpjBairro: '',
      consCnpjCidade: '',
      consCnpjEstado: '',
      consCnpjImpEndereco: true,
      consCnpjImpNumero: true,
      consCnpjImpBairro: true,
      consCnpjImpCompl: true,
      consCnpjImpCidade: true,
      consCnpjImpEstado: true,

      dtListPesqUsuario: null,
      dtListPesqCorreioServico: null,
      correioServData: {},

      idWmsOsSelecionado: null,

      numerosPedidosSelecionados: [],

      exibirNovaPlp: true,
      loadingMovPlp: false,
      movPlpLotesData: null,
      movPlpsData: [],
      movPlpLoteData: {
        'formato': '2',
        'layprint': 'LINEAR_100_150',
        'compinf': 1,
        'pesoinf': 1,
        'altuinf': 1,
        'larginf': 1,
        'prevpost': moment().format("YYYY-MM-DD")
      },
      submittedMovPlpLote: false,
      showModalPLPCorreios: false,

      showModalVolume: false,
      loadingWmsVolume: false,
      wmsOsVolumesData: {},
      wmsOsVolumeData: [],
      somaQtdVolumes: 0,
      somaPesoVolumes: 0,

      selecionarTodos: 'I',

      modoPesq: 'chavenf',
      chaveAddNf: '',
      showModalAddPedido: false,
      submittedAddPedido: false,
      listaSolicitacaoColeta: {},
      modalColeta: false,

      pedidosData: null,
      isTagiaHost: false,
      sincronizando: false,
      showModalDetalhes: false,

      showModalTransp: false,
      isNovoRomaneio: false,
      loadingTransp: false,
      dtListPesqTransp: null,
      transpData: {
        servtransp: null,
      },

      userLogged: null,

      contTotalItens: 0,
      showModalAnexoList: false,
      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasAnexoData: null,


      showModalMediaJson: false,
      mediaJsonCorpem: {},
      showModalXML: false,
      xmlContent: '1,2,3',
      mediasData: {},
      submitMovCompraItem: false,

      loadingMovCompraItem: false,
      loadingWmsEnder: false,


      dtlistPesqMovCompraItem: null,
      dtListPesqWmsEnder: null,


      showModalMovCompraItem: false,
      showModalObs: false,
      showModalImpXML: false,

      loadingDisparaColeta: false,
      imprimeSemTravaStatus: false,
      wmsRomaneioData: {
        id: 0,
        status: "EL",
        dtemissao: new Date
      },
      fornecedorData: {},

      formaPgtoData: {},
      pedTipoData: {},
      wmsRomaItemData: {},
      wmsRomaItensData: {},
      totalValorLiq: null,
      totalDesconto: null,
      totalValorBruto : null,
      valorFrete : null,


      somaPedidosFor: 0,
      ultPedsData: null,
      errosValid: null,

      idData: 0,
      updating: true,
      title: "Editar Romaneio",
      items: [
        {
          text: "Romaneios",
          href: "/wmsromaneios/list",
        },
        {
          text: "Editar Romaneio",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      currentPage: 1,
      pesqTextFilter: '',
      showModalImprimirEtiqLogistica: false,
      showModalEtiquetaLogistica: false,
      pdfUrl: '',
      flagGeraRomaOrcto: false,
      orcto_ref: null,
      showModalAddPedidoOrcto: false,
      submittedAddPedidoOrcto: false,
      modoPesqOrcto: "orcto_id",
      empresaData: {},
      movPlperro: false,
      idWmsOs: null,
      showModalAddPedidoTipo: false,
      tipoPedidoInput: null,
      tipoPedidoList: [
        { value: "mov",  text: 'Por Nota Fiscal' },
        { value: "wmsos",  text: 'Por Ordem de Saída' },
      ],
      showModalAddWmsOs: false,
      submittedAddWmsOs: false,
      qtdTotalDocumentos: 0,
      qtdTotalVolumes: 0
    };
  },
  validations: {
    wmsRomaItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'wmsRomaItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'wmsRomaItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  },
  mounted() {
    console.log('mounted_wmsRomaneio_editar_0')
    this.isTagiaHost = window.location.hostname.includes('tagia') || window.location.hostname.includes('localhost')

    let rota = this.$route.path

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()

    }else{
      this.title = `Criando Novo Romaneio`
      this.updating = false
      let emprAtu = localStorage.getItem('empratu')

      if (emprAtu) {
        this.wmsRomaneioData.empresa = emprAtu
      } else {
        this.wmsRomaneioData.empresa = '01'
      }

      this.isNovoRomaneio = true
      this.showModalTransp = true

    }

  },

  methods:{
    retryBuscarVolumesTagia(data) {
      console.log('retryBuscarVolumesTagia')
      console.log(data)

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Retentar busca Tagia",
        text: "Deseja retentar a busca de volumes da Tagia para a NF " + data.codigo + "? Pode levar alguns segundos.",
        confirmButtonText: "Sim, tentar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true

          api.post(`${getBaseUrl()}api/wmsromatagiaretry`, {
            wmsos_id: data.wmsosid
          }).then((res) => {
            console.log('retryBuscarVolumesTagia then')
            console.log(res.data)

            this.updating = false

            if (res.data.success) {
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 2500
              })
              this.carregarDados()
            } else {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Falha na busca Tagia",
                text: res.data.error,
                showConfirmButton: true
              })
            }
          })
        }
      })
    },

    sincronizarEtiquetas() {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Sincronizar Etiquetas",
        text: "Isso irá buscar etiquetas na Tagia para todas as notas sem volume deste romaneio. Continuar?",
        confirmButtonText: "Sim, sincronizar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (!result.isConfirmed) return

        this.sincronizando = true

        api.post(`${getBaseUrl()}api/wmsromaneio/${this.wmsRomaneioData.id}/sincronizar-etiquetas`)
          .then((res) => {
            const d = res.data
            const texto = `${d.sincronizados} de ${d.total} nota(s) sincronizada(s) com sucesso.`
            const falhasNotas = d.detalhes.filter(x => !x.ok && x.nota).map(x => x.nota).join(', ')
            const falhasTexto = d.falhas > 0 ? `\n${d.falhas} falha(s): ${falhasNotas}` : ''

            Swal.fire({
              position: "center",
              icon: d.falhas === 0 ? "success" : "warning",
              title: d.falhas === 0 ? "Sincronizado!" : "Concluído com falhas",
              text: texto + falhasTexto,
              showConfirmButton: true,
            })
            this.carregarDados()
          })
          .catch(() => {
            Swal.fire({
              position: "center",
              icon: "error",
              title: "Erro",
              text: "Não foi possível sincronizar as etiquetas.",
              showConfirmButton: true,
            })
          })
          .finally(() => {
            this.sincronizando = false
          })
      })
    },

    abrirModalTipoInput(){
      console.log("abrirModalTipoInput")
      //console.log(this.tipoPedidoInput)


      if(this.tipoPedidoInput === "mov"){
        this.showModalAddPedido = true
      } else if(this.tipoPedidoInput === "wmsos"){
        this.showModalAddWmsOs = true
        this.modoPesq = "wmsos"
      }

      this.showModalAddPedidoTipo = false
      //console.log(`modoPesq: ${this.modoPesq}`)
    },


    imprimirZipDanfePdf() {
    console.log('imprimirZipDanfePdf')

    let listSelecionados = []
    this.pedidosData.forEach((value) => {
      if (value.selecionado) {
        listSelecionados.push(value.id)
      }
    });

    if(listSelecionados.length < 1){
      this.showSwal('warning', 'center', 'Selecione pelo menos 1 nota!',  false, false, 2500)
      return
    }

    api.post(
      `${getBaseUrl()}api/romaXml2Danfe`,
      { listItens: listSelecionados },
      { responseType: 'blob' }
    )
    .then((res) => {
      const blob = new Blob([res.data], { type: 'application/zip' });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;

      let fileName = `danfes_romaneio_${this.idData}.zip`;

      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((err) => {
      console.log('Erro ao baixar ZIP', err);
      this.showSwal('error', 'top-end', 'Erro interno! Contacte suporte',  false, false, 2500)
    });
  },


    setFocus() {
      if ( this.modoPesq === 'chavenf'){
        this.$refs.chavenfInput.focus();
      } else if (this.modoPesq === 'nf') {
        this.$refs.nvInput.focus();
      }
    },

    showSwal(icon, position, message, confirmButton, cancelButton, timer){
      Swal.fire({
        icon: icon,
        position: position,
        text: message,
        showConfirmButton: confirmButton,
        showCancelButton: cancelButton,
        timer: timer
      })
    },

    reenvioEmailEmbarque() {
      console.log('reenvioEmailEmbarque')

      api.get(`${getBaseUrl()}api/wmsromareenvmail`, {
        params: {
          wmsromaneio_id: this.idData
        }
      }).then((res) => {
        console.log('then reenvioEmailEmbarque')
        console.log(res.data)

        let icon = res.data.envios_com_erro.length === 0 ? 'success' : 'warning'

        const movIdsSucesso = res.data.envios_realizados.map(e => e.mov_id)
        const movIdsErro = res.data.envios_com_erro.map(e => e.mov_id)

        let detalhes = ''
        if (movIdsSucesso.length > 0) {
          detalhes += `Enviados com sucesso (ID): ${movIdsSucesso.join(', ')}.\n`
        }
        if (movIdsErro.length > 0) {
          detalhes += `Com erro (ID): ${movIdsErro.join(', ')}.`
        }

        this.showSwal(icon, 'top-end', res.data.message + '\n\n' + detalhes, false, false, 8000)
      })
    },

    confAnexo() {
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.dropzoneFile.name) {
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/wmsromafileanexo`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios confAnexo')
          console.log(res)
          this.loadingFiles = false
          this.dropzoneFile = ''

          if(res.data.success){
            this.showSwal('success', 'top-end', res.data.message, false, false, 2000)
          }else{
            this.showSwal('error', 'top-end', res.data.message, false, false, 2000)
          }

        }).catch((err) => {
          this.dropzoneFile = ''

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },

    novoAnexo() {
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },

    visualizarComprovante(){
      api.get(`${getBaseUrl()}api/getromacomprovante`, {
        params: {
          iddata: this.wmsRomaneioData.id
        },
        responseType: 'blob'  // Solicita o retorno como blob para download direto
      }).then((res) => {
        console.log('then visualizarComprovante');
        console.log(res.data);

        if (res.data) {
          const fileURL = window.URL.createObjectURL(res.data);
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;

          // Define o nome do arquivo com base no cabeçalho `Content-Disposition`
          const contentDisposition = res.headers['content-disposition'];
          const fileName = contentDisposition ?
              contentDisposition.split('filename=')[1].replace(/"/g, '') :
              `comprovante_romaneio_${this.wmsRomaneioData.id}`;

          fileLink.setAttribute('download', fileName);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Comprovante não existente!',
            showConfirmButton: false,
            showCancelButton: false,
            timer: 2000
          });
        }
      });
    },

    focusFindEtiqLogistica(){
      console.log('setting focus...')

      setTimeout(() => {
        this.$refs.findEtiqLogistica.focus()
      }, 100)
    },

    imprimirEtiquetaLogistica(chave, wmsos_id){
      console.log('imprimirEtiquetaLogistica - chave: ' + chave)

      api.get(`${getBaseUrl()}api/imprimiretiqlogistica`, {
        params: {
          chave: chave,
          wmsos_id: wmsos_id
        }
      }).then((res) => {
        console.log('then imprimirEtiquetaLogistica...')
        console.log(res.data)

        if(res.data.success){
          const base64Pdf = res.data.base64
          const url = `data:application/pdf;base64,${base64Pdf}`
          this.pdfUrl = url
          this.showModalEtiquetaLogistica = true
          this.chaveAddNf = ''

        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 3000
          })
        }
      })
    },

    selectPedido(pedido){
      console.log(`Pedido ${pedido.id} - status selecionado atual: ${!pedido.selecionado}`)

      this.pedidosData.find((value) => {
        if(value.id === pedido.id){
          console.log(value)
          value.selecionado = !pedido.selecionado
        }
      })
    },

    imprimirEtiquetas(){
      console.log('imprimirEtiquetas...')

       let count = 0
       this.pedidosData.forEach((value) => {
        if(value.selecionado === true){
          this.listaImpressaoMiniDanfe.push(value)
          count++
        }
      })

      console.log(`Pedidos a imprimir: ${count}`)
      console.log(this.listaImpressaoMiniDanfe)

      if(this.listaImpressaoMiniDanfe.length > 0 && count > 0){
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: 'Fila de impressão enviada!',
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          api.post(`${getBaseUrl()}api/impminidanferomaneio`, {
            idData: this.idData,
            listaPedidos: this.listaImpressaoMiniDanfe
          }).then((res) => {
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.pedidosData.forEach((value) => {
                  value.selecionado = false
                })

                this.$refs.selecionarTodos = false
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "danger",
                title: res.data.message,
                showConfirmButton: false,
                timer: 2000
              }).then(() => {
                this.pedidosData.forEach((value) => {
                  value.selecionado = false
                })

                this.$refs.selecionarTodos = false
              })
            }
          })
        })
      }else{
        Swal.fire({
          position: "center",
          icon: "warning",
          title: 'Nenhum pedido selecionado para impressão!',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },

    atualizaPagina() {
      window.location.reload();
    },

    dispararColetaIndividual(numnf){
      console.log(`disparo individual de coleta... NF-e: ${numnf}`)

      api.post(`${getBaseUrl()}api/solicitacoletauni`, {
          idData: this.idData,
          numnf: numnf
        }).then((res) => {
          console.log(res)
          if(res.data.success){
            Swal.fire({
            position: "top-end",
            icon: "info",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 2000
            })
          }else{
            Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 2000
            })
          }
        }).then(() => {
          this.atualizaPagina()
        })
    },

    formatarData(data) {
      return data ? moment(data).format('DD/MM/YYYY HH:mm:ss') : "não gerado";
    },

    SolicitacaoColetaexportExcel(){
      console.log('SolicitacaoColetaexportExcel')
      const data = this.listaSolicitacaoColeta
      const fileName = `Solicitacao_${this.idData}`;
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });
    },

    consultarCEP(){
      console.log('consultarCEP')
      const cepTratado = this.clienteData.cep.replaceAll('.','').replaceAll('-','')
      if (cepTratado.length !== 8){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "O campo CEP deve possuir no mínimo 8 caracteres, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }else{
        console.log(cepTratado)
        console.log(cepTratado.length)
        this.showModalConsCEP = true
        this.loadingDadosCep = true

        api.get(`${getBaseUrl()}api/conscep`, {
          params: { cep: cepTratado }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          const dataCep = res.data[0]

          this.consCnpjEndereco = dataCep.logradouro
          this.consCnpjCompl = dataCep.complemento
          this.consCnpjBairro = dataCep.bairro
          this.consCnpjCidade = dataCep.localidade
          this.consCnpjEstado = dataCep.uf
          this.consCnpjCodMun = dataCep.ibge

          if (res.data[1]){
            console.log('res.data[1]')
            console.log(res.data[1])
            this.cidadeData = res.data[1]
          }

          this.consCnpjImpEndereco = this.clienteData.rua !== this.consCnpjEndereco
          this.consCnpjImpCompl = this.clienteData.compl !== this.consCnpjCompl
          this.consCnpjImpBairro = this.clienteData.bairro !== this.consCnpjBairro
          this.consCnpjImpCidade = this.clienteData.cidade !== this.consCnpjCidade



          this.loadingDadosCep = false
        });
      }
    },

    buscaCEP(){
      console.log('buscaCEP')

      if( this.clienteData.estado && this.clienteData.cidade && this.clienteData.cidade.length > 3 &&
          this.clienteData.rua && this.clienteData.rua.length > 3 ) {

        this.loadingDadosCep = true

        console.log('buscaCEP no if')

        api.get(`${getBaseUrl()}api/buscacep`, {
          params: {
            uf: this.clienteData.estado,
            cid: this.clienteData.cidade,
            rua: this.clienteData.rua
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          const dataCep = res.data[0]

          this.consCnpjEndereco = dataCep.logradouro
          this.consCnpjCompl = dataCep.complemento
          this.consCnpjBairro = dataCep.bairro
          this.consCnpjCidade = dataCep.localidade
          this.consCnpjEstado = dataCep.uf
          this.consCnpjCodMun = dataCep.ibge

          if (res.data[1]){
            console.log('res.data[1]')
            console.log(res.data[1])
            this.cidadeData = res.data[1]
          }

          this.consCnpjImpEndereco = this.clienteData.rua !== this.consCnpjEndereco
          this.consCnpjImpCompl = this.clienteData.compl !== this.consCnpjCompl
          this.consCnpjImpBairro = this.clienteData.bairro !== this.consCnpjBairro
          this.consCnpjImpCidade = this.clienteData.cidade !== this.consCnpjCidade

          this.loadingDadosCep = false
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Para a busca do CEP é obrigatório os seguintes campo UF, Cidade e Logradouro, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarImpCep(){
      console.log('confirmarImpCep: ')
      if (this.consCnpjImpEndereco){
        this.clienteData.rua = this.consCnpjEndereco
      }
      if (this.consCnpjImpBairro){
        this.clienteData.bairro = this.consCnpjBairro
      }
      if (this.consCnpjImpCidade){
        this.clienteData.cidade = this.consCnpjCidade
        this.clienteData.estado = this.consCnpjEstado
        this.clienteData.codmun = this.consCnpjCodMun
        this.dtListPesqCidade = [
          {
            'codigo': this.cidadeData.codigo,
            'descricao': this.cidadeData.descricao
          },
        ]

      }
      if (this.consCnpjImpCompl){
        this.clienteData.compl = this.consCnpjCompl
      }

      this.showModalConsCEP = false

    },

    confirmarEnderEntrega(){
      console.log('confirmarEnderEntrega')
      this.submittedEnderEntrega = true
      this.loadingCliente = true

      if (this.clienteData.cep && this.clienteData.rua && this.clienteData.numero && this.clienteData.cidade) {

        api.post(`${getBaseUrl()}api/cliente`, {
          clienteData: this.clienteData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.loadingCliente = false


          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.showModalEnderEntrega = false
          this.carregarDados()


        })

      }

    },


    consEnderEntrega(codCli){
      console.log('consEnderEntrega')
      console.log(codCli)
      this.showModalEnderEntrega = true
      this.loadingCliente = true

      api.get(`${getBaseUrl()}api/clicod`, {
        params: { coddata: codCli }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]
        this.loadingCliente = false


        this.dtListPesqCidade = [
          {
            'codigo': this.clienteData.codmun,
            'descricao': this.clienteData.cidade,
          }
        ]

        //this.loadingCliente = false
      })



    },


    pesqCidade(evt){
      console.log('pesqCidade')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCidade = res.data
        });
      }
    },

    escolheuCidade(){
      console.log('escolheuCidade')
      // console.log(this.clienteData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: { coddata: this.clienteData.codmun }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData.cidade = res.data.descricao
        this.clienteData.estado = res.data.estado

      })
    },



    pesqUsuario(evt){
      console.log('pesqUsuario')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/userpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqUsuario = res.data
        });
      }
    },


    integerOnly(event) {
      event.target.value = Math.floor(event.target.value);
    },



    solicitarRotulo(rowData){
      console.log('solicitarRotulo')
      console.log(rowData)
      this.loadingMovPlp = true
      if (rowData.recibo) {
        api.get(`${getBaseUrl()}api/movplprotuimpr`, {
          params: {
            'iddata': rowData.id
          }
        }).then((res) => {
          console.log('then axios rotular plp')
          // console.log(res.data)
          this.loadingMovPlp = false

          if(res.data[0] === 'erro') {

            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[1],
              showConfirmButton: false,
              timer: 3500
            })
          } else {
            const linkSource = `data:application/pdf;base64,${res.data}`;
            const downloadLink = document.createElement("a");
            const fileName = `etiqueta_correios_${ rowData.codobj }.pdf`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          }

        })
      } else {
        api.get(`${getBaseUrl()}api/movplprotu`, {
          params: {
            'iddata': rowData.id
          }
        }).then((res) => {
          console.log('then axios rotular plp')
          console.log(res.data)
          this.loadingMovPlp = false
          this.movPlpsData = res.data[0]
          // console.log('this.movPlpsData')
          // console.log(this.movPlpsData)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'O rótulo foi solicitado com sucesso',
            showConfirmButton: false,
            timer: 1500
          })
        })
      }
    },


    consultarObjeto(rowData) {
      console.log('consultarObjeto')
      console.log(rowData.codobj)
      this.loadingMovPlp = true
      if (!rowData.codobj || rowData.codobj === '') {
        api.get(`${getBaseUrl()}api/movplpconsobj`, {
          params: {
            'iddata': rowData.id
          }
        }).then((res) => {
          console.log('then axios consultar objeto')
          console.log(res.data)
          this.loadingMovPlp = false
          this.movPlpsData = res.data[0]
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'Consulta realizada com sucesso',
            showConfirmButton: false,
            timer: 1500
          })
        })
      } else {
        api.get(`${getBaseUrl()}api/movplprastobj`, {
          params: {
            'iddata': rowData.id
          }
        }).then((res) => {
          console.log('then axios rastrear objeto')
          console.log(res.data)
          this.loadingMovPlp = false
          // this.movPlpsData = res.data[0]
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data[0],

            showConfirmButton: false,
            timer: 2500
          })
        })
      }



    },


    solicitarRotuloLote(idLote){
      console.log('solicitarRotulo')
      console.log(idLote)
      this.loadingMovPlp = true
      if (idLote) {

        api.get(`${getBaseUrl()}api/movplprotulote`, {
          params: {
            'idlote': idLote,
            'layout': this.movPlpLoteData.layprint
          }
        }).then((res) => {
          console.log('then axios rotular plp')
          console.log(res.data)
          this.loadingMovPlp = false
          this.movPlpsData = res.data[0]

          const rowData = this.movPlpsData[0]
          console.log('rowData: ' , rowData)
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'O rótulo foi solicitado com sucesso!',
            showConfirmButton: false,
            timer: 1500
          })

          this.solicitarRotulo(rowData)
          this.carregarDados()
        })
      }
    },



    consultarTodosObjetos(idLote){
      console.log('consultarTodosObjetos')
      console.log(idLote)
      this.loadingMovPlp = true
        api.get(`${getBaseUrl()}api/movplpconsobjlote`, {
          params: {
            'iddata': idLote
          }
        }).then((res) => {
          console.log('then axios consultar objetos lote')
          console.log(res.data)

          if (res.data[0] === 'erro') {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[1],
              showConfirmButton: false,
              timer: 3500
            })

            this.loadingMovPlp = false
          } else {
            this.movPlpsData = res.data[0]
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: 'Consulta de Objetos realizada com sucesso!',
              showConfirmButton: false,
              timer: 2500
            })

            this.solicitarRotuloLote(idLote)

          }

        })
    },


    cancelarMovPlp(idData){
      console.log('cancelarMovPlp')
      console.log(idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: `Cancelamento de PLP ${idData}`,
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar Cancelamento",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          //this.$emit('deletareg', idData)
          this.loadingMovPlp = true
          api.get(`${getBaseUrl()}api/movplpcanc`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios cancelar plp')
            console.log(res.data)
            this.loadingMovPlp = false

            this.movPlpsData.forEach((value) => {
              console.log('valueId')
              console.log(value.id)
              console.log(idData)

              console.log(typeof value.id)
              console.log(typeof idData)

              if (value.id === idData){
                value.status = '5'
                value.descstatus = 'Cancelado'
                value.recibo = null
              }
            })

            console.log(this.movPlpsData)

            // this.movPlpsData = res.data[0]
            // this.exibirNovaPlp = true
            // this.movPlpsData.forEach((movPlp) => {
            //   if (movPlp.status !== '5'){
            //     this.exibirNovaPlp = false
            //   }
            // })
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: 'O registro foi cancelado com sucesso',
              showConfirmButton: false,
              timer: 1500
            })
          })
        }
      })
    },


    retornoSolicitacaoColeta(){
      console.log('retornoSolicitacaoColeta')
      api.get(`${getBaseUrl()}api/getcoleta`, {
        params:{
          'idData': this.idData
        }
      }).then((res) => {
        console.log('then axios getcoleta');
        console.log(res.data);

        this.listaSolicitacaoColeta = res.data;
      }).catch((error) => {
        console.error('Erro ao obter dados:', error);
      });
    },

    disparaColeta(){
      console.log('dispara coleta')

      let count = 0
      this.pedidosData.forEach((value) => {
        if(value.selecionado === true){
          count++
        }
      })

      if(count > 0){
        // console.log('Pedidos Selecionados: ' , count)

        this.loadingDisparaColeta = true
        Swal.fire({
          position: "center",
          icon: "info",
          title: 'Solicitação enviada!',
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          api.post(`${getBaseUrl()}api/solicitacoleta`, {
            idData: this.wmsRomaneioData.id,
            manual: true
          }).then((res) => {
            console.log('then axios disparaColeta')
            console.log(res.data)

            if(res.data.success === true){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: 'Foram concluídos com sucesso: ' + res.data.contsucesso + '\nTiveram erro: ' + res.data.conterro + '\nMensagem de erro:\n' + res.data.msg_retorno,
                showConfirmButton: false,
                timer: 5000
              }).then(() => {
                this.carregarDados()
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: res.data.mensagem,
                showConfirmButton: true,
              }).then(() => {
                this.carregarDados()
              })
            }
            this.loadingDisparaColeta = false
          })
        })
      }else{
        Swal.fire({
          position: "center",
          icon: "warning",
          title: 'Nenhum pedido selecionado para disparo de coleta!',
          showConfirmButton: false,
          timer: 2000
        })
      }
    },

    consPLPLoteCorreios(idLote){
      console.log('consPLPLoteCorreios idLote:')
      console.log(idLote)
      this.loadingMovPlp = true
      api.get(`${getBaseUrl()}api/movsplpcorreioscons`, {
        params: { idlote: idLote }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.movPlperro = false
        if (res.data[0] === 'erro') {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data[1],
            showConfirmButton: false,
            timer: 3500
          }).then(() => {
            this.loadingMovPlp = false
            // this.movPlperro = true

            this.carregarDados()
          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'Consulta de Lote realizada com sucesso!',
            showConfirmButton: false,
            timer: 2500
          })

          this.movPlpLotesData = res.data[0]
          this.movPlpsData = res.data[1]
          
          this.consultarTodosObjetos(idLote)
        }
      })
    },

    async aceitePLP(data) {
      console.log('aceitePLP')
      // console.log(data)

      const result = await Swal.fire({
        position: "center",
        icon: "info",
        title: 'Aceite necessário!',
        html: `
        <h4>Cláusula de Aceite e Responsabilidade:</h4>
        <h5>Ao prosseguir com a contratação deste serviço, o usuário declara estar ciente de que, caso o valor do bem ou serviço contratado ultrapasse o limite máximo ou seja inferior ao limite mínimo estabelecido 
          pela política vigente, toda e qualquer consequência financeira, incluindo eventuais prejuízos, perdas ou ônus decorrentes da operação, será de inteira responsabilidade do contratante que realizou o aceite, 
          isentando a contratada de qualquer obrigação ou ressarcimento.</h5>
        `,
        input: 'text',
        inputLabel: 'Nome e Sobrenome',
        showConfirmButton: true,
        showDenyButton: true,
        confirmButtonText: 'Confirmar',
        denyButtonText: `Cancelar`,
        didOpen: () => {
          const container = Swal.getContainer();
          if (container) {
             container.addEventListener('focusin', (e) => {
                 e.stopPropagation();
             });
          }
        },
        inputValidator: (value) => {
          if (!value) {
            return 'Você precisa digitar seu nome e sobrenome para confirmar!' // Mensagem de validação se o campo estiver vazio
          }
        }
      })

      console.log('aceitePLP')
      // console.log(result)

      if(result.isConfirmed) {
        data.nomeaceite = result.value
        data.dataaceite = new Date()
        return true
      } else {
        return false
      }
    },

    async confPLPLoteCorreios(data=null){
      console.log('confPLPLoteCorreios')

      let pedSelecionados = []
      this.pedidosData.forEach((value) => {
        if (value.selecionado === true){
          pedSelecionados.push(value.id)
        }
      })
      if (pedSelecionados.length === 0) {

        Swal.fire({
          position: "top-end",
          icon: "error",
          title: 'Nenhum movimento foi selecionado para criar PLP, favor selecionar.',
          showConfirmButton: false,
          timer: 3500
        })

      } else {
        if (data && data.id && data.idlote) {
          const result = await this.aceitePLP(data)
          if (!result || typeof result === 'undefined') {
            await Swal.fire({
              position: "top-end",
              icon: "error",
              title: 'A pré-postagem com erro não será reenviada.',
              timer: 3500
            })
            return
          }
        }

        if (this.movPlpLoteData.formato && this.movPlpLoteData.servico && this.movPlpLoteData.compinf
            && this.movPlpLoteData.pesoinf && this.movPlpLoteData.altuinf && this.movPlpLoteData.larginf
            && this.movPlpLoteData.prevpost) {
          this.loadingMovPlp = true
          
          
          
          api.post(`${getBaseUrl()}api/movsplpcorreios`, {
            idsData: pedSelecionados,
            movPlpLoteData: this.movPlpLoteData,
            wmsRomaIdData: this.idData,
            loteData: data ?? null
          }).then(res => {
            console.log('then axios')
            console.log(res)
            this.loadingMovPlp = false

            if (res.data[0] === 'erro') {
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: 'Erro na execução do processo',
                text: res.data[1],
                showConfirmButton: false,
                timer: 3500
              })
            } else {
              this.movPlpLotesData = res.data[0]
              this.movPlpsData = res.data[1]

              //this.exibirNovaPlp = false

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: 'O registro foi criado com sucesso',
                showConfirmButton: false,
                timer: 1500
              })
            }

          }).catch(err => {
            console.log('catch axios')
            // console.log(err)
            this.loadingMovPlp = false
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: 'Erro na execução do processo',
              text: err.response.data[0].erro,
              showConfirmButton: false,
              timer: 3500
            })
          }).finally(() => {
            console.log('finally axios')
            this.carregarDados()
          })
        }
      }
    },

    atualizarTotalSelecionado() {
      let total = 0;
      this.pedidosData.forEach((value) => {
        if (value.selecionado) {
          total++;
        }
      });
      this.totalSelecionado = total;
    },

    selecionaTodos() {
      console.log('selecionaTodos');
      console.log(this.selecionarTodos);

      this.pedidosData.forEach((value) => {
        value.selecionado = this.selecionarTodos;
      });

      this.atualizarTotalSelecionado();
    },

    selecionarItem(item) {
      item.selecionado = !item.selecionado; // Inverte o estado de seleção do item
      this.atualizarTotalSelecionado(); // Atualiza a contagem
    },


    plpCorreios(){
      console.log('plpCorreios')
      console.log(this.totalCorreioServ)

      if (this.totalCorreioServ > 0) {

        this.numerosPedidosSelecionados = []
        this.qtdSelecionados = 0
        this.pedidosData.forEach((value) => {
          if (value.selecionado === true) {
            this.qtdSelecionados ++
            this.numerosPedidosSelecionados.push(value.codigo)
          }
        })

        if (this.qtdSelecionados > 50) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "O limite máximo do Correios é de 50 NF's.",
            showConfirmButton: false,
            timer: 4500
          })

        } else if (this.transpData.apirastreio !== 'CORREIOS') {

          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Transportador atual não possui serviço Correios.",
            showConfirmButton: false,
            timer: 4500
          })

        } else {
          this.showModalPLPCorreios = true
        }

        console.log('selecionados: ' , this.qtdSelecionados)

      } else {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum serviço disponível para Correios, favor validar o token em Administrativo - Empresas - Tokens - Correios - Validar Token.",
          showConfirmButton: false,
          timer: 4500
        })

      }





    },




    abrirWmsOs(wmsosid) {
      console.log('abrirWmsOs: ' + wmsosid )
      const routeData = this.$router.resolve(`/wmsos/saidaeditarnova/${wmsosid}`)
      window.open(routeData.href, '_blank')
    },


    gerarWmsOs() {
      console.log('gerarWmsOs')
      this.updating = true


      api.get(`${getBaseUrl()}api/romawmsos`, {
        params: { idData: this.wmsRomaneioData.id }
      }).then((res) => {
        console.log('then axios gerar_wms_os_00')
        console.log(res.data)

        this.carregarDados()

      })

    },


    confirmarAddPedido(){
      console.log('confirmarAddPedido')
      this.submittedAddPedido = true

      //this.chaveAddNf
      if (this.chaveAddNf) {
        api.post(`${getBaseUrl()}api/wmsromaadped`, {
          iddata: this.idData,
          nfadd: this.chaveAddNf,
          modopesq: this.modoPesq
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          if (!res.data.success && res.data.error) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data.error,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.chaveAddNf = null;
            })
          } else {
            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.chaveAddNf = null;
                this.updating = false
                this.showModalAddPedido = false
                this.carregarDados()
              })
            }else{
              Swal.fire({
                position: "center",
                icon: "warning",
                title: res.data.message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Mover',
                cancelButtonText: 'Não'
              }).then((escolha) => {
                if(escolha.isConfirmed){
                  //disparar transferência de romaneio
                  api.post(`${getBaseUrl()}api/wmsromatransfnota`, {
                    iddata: this.idData,
                    nfadd: this.chaveAddNf,
                    modopesq: this.modoPesq
                  }).then((res) => {
                    console.log('then axios')
                    console.log(res.data)

                    this.chaveAddNf = null;

                    if(res.data.success){
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: res.data.message,
                        showConfirmButton: false,
                        timer: 1500
                      }).then(() => {
                        this.updating = false
                        this.showModalAddPedido = false
                        this.carregarDados()
                      })
                    }else{
                      Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: res.data.error,
                        showConfirmButton: false,
                        timer: 1500
                      }).then(() => {
                        this.updating = false
                        this.carregarDados()
                      })
                    }
                  })
                }else{
                  Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: 'Transferência cancelada!',
                    showConfirmButton: false,
                    timer: 1500
                  })
                }
              })
            }
          }
        })
      }
    },

    confirmarAddPedidoOrcamento(){
      console.log('confirmarAddPedidoOrcamento')
      this.submittedAddPedido = true

      if (this.orcto_ref) {
        api.post(`${getBaseUrl()}api/wmsromaadpedorcto`, {
          iddata: this.idData,
          orcto_ref: this.orcto_ref,
          modopesq: this.modoPesqOrcto
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          if (!res.data.success && res.data.error) {
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data.error,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.orcto_ref = null;
            })
          } else {
            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.orcto_ref = null;
                this.updating = false
                this.showModalAddPedido = false
                this.carregarDados()
              })
            }else{
              Swal.fire({
                position: "center",
                icon: "warning",
                title: res.data.message,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Mover',
                cancelButtonText: 'Não'
              }).then((escolha) => {
                if(escolha.isConfirmed){
                  //disparar transferência de romaneio
                  api.post(`${getBaseUrl()}api/wmsromatransfnota`, {
                    iddata: this.idData,
                    orcto_ref: this.orcto_ref,
                    modopesq: this.modoPesq
                  }).then((res) => {
                    console.log('then axios')
                    console.log(res.data)

                    this.orcto_ref = null;

                    if(res.data.success){
                      Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: res.data.message,
                        showConfirmButton: false,
                        timer: 1500
                      }).then(() => {
                        this.updating = false
                        this.orcto_ref = null
                        this.showModalAddPedidoOrcto = false
                        this.carregarDados()
                      })
                    }else{
                      Swal.fire({
                        position: "top-end",
                        icon: "error",
                        title: res.data.error,
                        showConfirmButton: false,
                        timer: 1500
                      }).then(() => {
                        this.updating = false
                        this.orcto_ref = null
                        this.carregarDados()
                      })
                    }
                  })
                }else{
                  Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: 'Transferência cancelada!',
                    showConfirmButton: false,
                    timer: 1500
                  }).then(() => {
                    this.orcto_ref = null
                  })
                }
              })
            }
          }
        })
      }
    },



    addPedido(){
      console.log('addPedido')

      if(this.flagGeraRomaOrcto){
        Swal.fire({
          position: "center",
          icon: "warning",
          title: 'Atenção',
          text: "Deseja adicionar pedido a partir de orçamento ou nota fiscal?",
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: 'Orçamento',
          cancelButtonText: 'Nota fiscal',
        }).then(check => {
          if(check.isConfirmed){
            this.showModalAddPedidoOrcto = true
          }else{
            this.showModalAddPedido = true
          }
        })
      }else{
        this.showModalAddPedidoTipo = true
      }
    },

    expedirRoma() {
      console.log('expedirRoma')
      this.$router.push(`/wmsromaneio/expedir/${this.idData}`)
    },

    escapeHtml(value) {
      return String(value ?? '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;')
    },

    finalizar() {
      console.log('finalizar')
      if (this.pedidosData.length > 0) {

        api.post(`${getBaseUrl()}api/wmsromacheckrastreio`, {
          idRomaneio: this.idData
        }).then((res) => {
          const notas = res.data.notas || []

          if (notas.length > 0) {
            const listaNotas = notas
                .map(n => `Nota Fiscal: ${this.escapeHtml(n.numnf ?? '-')} | Sistema de rastreio: ${this.escapeHtml(n.apirastreio)}`)
                .join('<br>')

            Swal.fire({
              position: "center",
              icon: "warning",
              title: "Notas com rastreio de carga vinculadas ao romaneio",
              html: `As seguintes notas vinculadas a este romaneio possuem rastreio de carga. Dependendo do retorno da transportadora, o status pode sair de "Em rota de entrega":<br><br>${listaNotas}`,
              confirmButtonText: "Continuar",
              showConfirmButton: true,
              showDenyButton: true,
              denyButtonText: "Continuar sem mudar status",
              showCancelButton: true,
              cancelButtonText: "Cancelar",
            }).then(escolha => {
              if (escolha.isConfirmed) {
                this.finalizarRomaneio(false)
              } else if (escolha.isDenied) {
                this.finalizarRomaneio(true)
              }
            })
          } else {
            this.finalizarRomaneio(false)
          }
        }).catch((err) => {
          console.log('Erro ao verificar rastreio do romaneio', err)
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Erro ao verificar rastreio das notas do romaneio",
            text: "Não foi possível concluir a verificação de rastreio. Tente novamente.",
            showConfirmButton: true,
          })
        })

      } else {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Mínimo de uma ordem de serviço associada ao Romaneio para finalizar ",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    finalizarRomaneio(pularStatusEnr) {
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Finalizar Romaneio",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          Swal.fire({
            position: "center",
            icon: "question",
            title: "Todas os volumes de etiquetas pendentes serão concluídos automaticamente!",
            text: "Tem certeza que desja continuar?",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true
          }).then(result2 => {
            if (result2.value){
              this.loadingFiles = true

              api.post(`${getBaseUrl()}api/wmsromaconf`, {
                iddata: this.idData
              }).then((res) => {
                console.log('then axios finalizar')
                console.log(res.data)
                //this.atualizaDataList()
                Swal.fire({
                  position: "top-end",
                  icon: "success",
                  title: res.data[1],
                  showConfirmButton: false,
                  timer: 3500
                }).then(() => {
                  console.log('solicitando coleta automática...')

                  Swal.fire({
                    position: "center",
                    icon: "info",
                    title: 'Solicitando coleta automática',
                    showConfirmButton: false,
                    timer: 1500
                  }).then(() => {
                    api.post(`${getBaseUrl()}api/solicitacoleta`, {
                      idData: this.idData,
                      pular_status_enr: pularStatusEnr
                    }).then((res) => {
                      console.log('then axios disparaColeta')
                      console.log(res.data)

                      if(res.data.success === true){
                        Swal.fire({
                          position: "top-end",
                          icon: "success",
                          title: res.data.mensagem,
                          showConfirmButton: false,
                          timer: 2500
                        })
                      }else{
                        Swal.fire({
                          position: "center",
                          icon: "error",
                          title: res.data.mensagem,
                          showConfirmButton: true,
                          timer: 10000
                        })
                      }
                    })
                  })
                })

                // this.loadingFiles = false
                this.carregarDados()
              })
            }
          })
        }
      })
    },


    cancelar() {
      console.log('cancelar')


      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelar Romaneio",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingFiles = true

          // api.get(`${getBaseUrl()}api/wmsromaconf`, {
          //   params: {
          //     'iddata': this.idData
          //   }
          // })

          api.post(`${getBaseUrl()}api/wmsromacanc`, {
            iddata: this.idData
          }).then((res) => {
            console.log('then axios finalizar')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Romaneio finalizaado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            // this.loadingFiles = false
            this.carregarDados()
          })


        }
      })


    },


    imprimir() {
      this.updating = true

      if (!this.imprimeSemTravaStatus && this.wmsRomaneioData.status != 'EQ' && this.wmsRomaneioData.status != 'FN') {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Romaneio não finalizado, favor finalizar o romaneio antes de imprimir",
          showConfirmButton: false,
          timer: 3000
        })
        this.updating = false
        return
      }

      api.get(`${getBaseUrl()}api/relroma01`, {
        params: {
          iddata: this.wmsRomaneioData.id
        },
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_romaneio' + this.idData + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },

    imprimirSepPedPorPage() {
      console.log('imprimirSepPedPorPage')
      this.updating = true

      api.get(`${getBaseUrl()}api/relromasep01`, {
        params: {
          iddata: this.wmsRomaneioData.id
        },
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_separacao_' + this.idData + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })
    },

    imprimirSep() {
      console.log('imprimirSep')
      this.updating = true

      api.get(`${getBaseUrl()}api/relromasep02`, {
        params: {
          iddata: this.wmsRomaneioData.id
        },
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_separacao_' + this.idData + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },

    imprimirSepAgr() {
      console.log('imprimirSep')
      this.updating = true

      api.get(`${getBaseUrl()}api/relromasep03`, {
        params: {
          iddata: this.wmsRomaneioData.id
        },
        responseType: 'blob'
      }).then((res) => {
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'Relatorio_separacao_' + this.idData + '.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
        this.updating = false
      })

    },


    deletarRomPed(iddata){
      console.log('deletar: ' + iddata)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Remover Associação de Romaneio",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingFiles = true

          api.get(`${getBaseUrl()}api/wmsromadesa`, {
            params: {
              'iddata': iddata
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações salvas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.loadingFiles = false
            this.carregarDados()
          })


        }
      })
    },

    desvRomPed(iddata){
      console.log('desvincular: ' + iddata)
      Swal.fire({
        position: 'center',
        icon: 'question',
        title: 'Desvincular Nota fiscal',
        text: 'Essa operação irá remover a NF-e do romaneio atual. tem certeza que deseja continuar?',
        showConfirmButton: true,
        showCancelButton: true
      }).then((result) =>{
        if (result.value) {

          api.get(`${getBaseUrl()}api/wmsromadesv`, {
            params: {
              'iddata': iddata
            }
          }).then((res) => {
            console.log('then axios desvRomPed')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data,
              showConfirmButton: false,
              timer: 1500
            })

            this.carregarDados()
          })


        }
      })
    },

    confirmarObs(){
      console.log('alteraTransp')
      this.showModalObs = false
      this.salvar()
    },

    confirmarRota(){
      console.log('alteraRota')

      this.showModalRota = false
      this.salvar()
    },

    confirmarDetalhes(){
      console.log('alteraTransp')
      this.showModalDetalhes = false
      this.salvar()
    },

    alteraTransp(){
      console.log('alteraTransp')
      if (this.wmsRomaneioData.status === 'EL'){
        this.showModalTransp = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    selecionaTransp(){
      console.log('selecionaTransp')
      if (this.wmsRomaneioData.status === 'EL') {
        console.log(this.wmsRomaneioData.transp)
        this.showModalTransp = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarTransp(){
      console.log('confirmarTransp')
      this.showModalTransp = false
      this.salvar()
    },

    pesqTransp(evt){
      console.log('pesqTransp')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true
        // this.wmsRomaneioData.transp = ''
        api.get(`${getBaseUrl()}api/transpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqTransp = res.data
        })
      }
    },

    pesqCorreioServico(evt){
      console.log('pesqCorreioServico')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/corservpesq`, {
          params: { q: query, emp: this.wmsRomaneioData.empresa }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCorreioServico = res.data
        })
      }
    },

    escolheuTransp(){
      console.log('escolheuTransp')
      this.loadingTransp = true
      console.log(this.wmsRomaneioData.transp)
      api.get(`${getBaseUrl()}api/clicnpj`, {
        params: { cnpjdata: this.wmsRomaneioData.transp }
      }).then((res) => {
        console.log('then axios_escolheu_transp')
        console.log(res.data)
        this.transpData = res.data[0]
        this.movPlpLoteData.servico = this.transpData.servtransp ?? null
        this.loadingTransp = false

        this.showModalTransp = false
        this.isNovoRomaneio = false
      })
      this.salvar()
    },

    abrirModalVol(data) {
      console.log('pedido :::', data)
      const pedido = this.pedidosData.find(pedido => (pedido.wmsosid ?? pedido.wmsos_id) === (data.wmsosid ?? data.wmsos_id));

      this.idWmsOsSelecionado = pedido.wmsosid ?? pedido.wmsos_id

      console.log('pedido :::')
      console.log(pedido)

      console.log('pedido/volumes :::')
      console.log(pedido.volumes)

      if (pedido.volumes) {
        this.wmsOsVolumesData = pedido.volumes;

        console.log('wmsOsVolumesData volumes ID:::')
        console.log(this.wmsOsVolumesData)
        let totalVols = 0
        let pesoVols = 0
        this.wmsOsVolumesData.forEach((value) => {
           totalVols += value.qtd
           pesoVols += value.peso
         });
        this.somaQtdVolumes = totalVols
        this.somaPesoVolumes = pesoVols
      }
      this.showModalVolume = true;
    },

     excluirEtiquetas() {
       console.log('excluirEtiquetas de OS:', this.idWmsOsSelecionado)
       this.showModalVolume = false
       this.somaQtdVolumes = 0
       this.somaPesoVolumes =  0

       this.wmsosid = this.idWmsOsSelecionado

       Swal.fire({
         position: "center",
         icon: "question",
         title: "Excluir Todas as Etiquetas",
         text: "Esta operação é irreversível, tem certeza que deseja continuar?",
         confirmButtonText: "Confirmar",
         cancelButtonText: "Cancelar",
         showCancelButton: true,
         showConfirmButton: true,
       }).then(result => {
         if (result.value) {
           this.updating = true
           api.delete(`${getBaseUrl()}api/wmsosetiquetas`, {
             params: {
               'iddata': this.wmsosid
             }
           }).then((res) => {
             console.log('then axios delete')
             console.log(res.data)
             this.carregarDados()
             Swal.fire({
               position: "top-end",
               icon: "success",
               title: "Informações excluídas com sucesso!",
               showConfirmButton: false,
               timer: 1500
             })
           })
         }
       })

     },

     informouQtdVolume() {
       console.log('informouQtdVolume')
       this.$refs.pesovolume.focus()

     },

     informouPeso() {
       console.log('informouPeso')
       this.confirmarVolume()

     },

     confirmarVolume() {

      console.log("wmsOsVolumesData:", this.wmsOsVolumesData);
      console.log("WMS OS ID:" + this.idWmsOsSelecionado);

      if (this.wmsOsVolumeData.qtd > 0 && this.wmsOsVolumeData.peso > 0) {
        this.loadingWmsVolume = true

        this.wmsosid = this.idWmsOsSelecionado


        // this.loadingWmsEnder = true
        // console.log(this.wmsOsItemSepData.produto)
        api.post(`${getBaseUrl()}api/wmsosconfvol`, {
          'idwmsos': this.wmsosid,
          'qtd': this.wmsOsVolumeData.qtd,
          'peso': this.wmsOsVolumeData.peso,
        }).then((res) => {
          console.log('then axios conf_vol')
          console.log(res.data)

          if (res.data.error){
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data.error,
              showConfirmButton: false,
              timer: 3000
            })
          } else {
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: 'Volume cadastrado com sucesso!',
              showConfirmButton: false,
              timer: 1500
            })
            this.wmsOsVolumesData = res.data[0]
            let totalVols = 0
            let pesoVols = 0
            this.wmsOsVolumesData.forEach((value) => {
              totalVols += value.qtd
              pesoVols += value.peso
            });
          
            this.somaQtdVolumes = totalVols
            this.somaPesoVolumes = pesoVols
          }
          this.$refs.qtdvolume.focus()
          this.loadingWmsVolume = false
          this.wmsOsVolumeData = {}
        })
      }

      this.carregarDados()
     },



     nomeOrigem(strEntr){
       let result = 'Não Definido'
       switch (strEntr) {
         case 'movcompra':
           result = 'Compra'
           break
         case 'pedido':
           result = 'Pedido'
           break
         default:
           result = 'Não Definido'
           break
       }
       return result
     },



     onPageChange(){
       console.log('onPageChange')
       console.log(this.currentPage)

     },





     calculaTotalItem(){
       console.log('calculaTotalItem')

       let quant = this.wmsRomaItemData.qtd
       let vlrUnit = this.wmsRomaItemData.vlrunitliq
       let vlrUnitTab = this.wmsRomaItemData.vlrunitbrt
       let percDesc = 0

       if (quant > 0 && vlrUnit > 0){

         let valorTotalItem = quant * vlrUnit
         console.log('valorTotalItem')
         console.log(valorTotalItem)

         if (vlrUnit !== vlrUnitTab){
           percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
         }


         this.wmsRomaItemData.desconto = percDesc
         this.wmsRomaItemData.vlrtotalbrt = vlrUnitTab * quant
         this.wmsRomaItemData.vlrtotalliq = valorTotalItem
       }

     },



     detalhesProduto(idProd){
       console.log('detalhesProduto: ' + idProd)

       this.$router.push(`/produto/detalhe/${idProd}`);

       // let route = this.$router.resolve({ path: "/contact" });
       // window.open(route.href);


     },

     editarProduto(idProd){
       console.log('editarProduto: ' + idProd)

       if (this.wmsRomaneioData.status === 'EL'){
         this.showModalMovCompraItem = true
         this.loadingMovCompraItem = true

         api.get(`${getBaseUrl()}api/movcompraitem`, {
           params: { iddata: idProd }
         }).then((res) => {
           console.log('then axios')
           console.log(res.data[0])

           this.wmsRomaItemData = res.data[0]

           if (this.wmsRomaItemData.imgs){
             let imgTrat = this.wmsRomaItemData.imgs.split(',')
             this.wmsRomaItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
           }

           this.loadingMovCompraItem = false
         })
       }else{
         Swal.fire({
           position: "top-end",
           icon: "warning",
           title: "Status de movimento não permite alteração",
           showConfirmButton: false,
           timer: 1500
         })
       }
     },

     confirmar(){
       console.log('confirmar: ' + this.idData)

       if (!this.wmsRomaItensData || this.wmsRomaItensData.length <= 0){
         Swal.fire({
           position: "top-end",
           icon: "warning",
           title: "Favor adicionar produto a compra antes de confirmar",
           showConfirmButton: false,
           timer: 1500
         })
       }else{
         Swal.fire({
           position: "center",
           icon: "question",
           title: "Confirmação de Compra",
           text: "Esta operação é irreversível, tem certeza que deseja continuar?",
           confirmButtonText: "Confirmar",
           cancelButtonText: "Cancelar",
           showCancelButton: true,
           showConfirmButton: true,
         }).then(result => {
           if (result.value) {
             this.updating = true
             api.post(`${getBaseUrl()}api/movcompraconf`, {
               iddata: this.idData
             }).then((res) => {
               console.log('then axios')
               console.log(res)

               this.updating = false
               Swal.fire({
                 position: "top-end",
                 icon: "success",
                 title: "Compra confirmada com sucesso",
                 showConfirmButton: false,
                 timer: 1500
               }).then((res) =>{
                 console.log(res)
                 this.$router.push(`/wmsromaneios/list`)

               })
             })
           }
         })
       }
     },




     alteraObs(){
       console.log('alteraObs')
       if (this.wmsRomaneioData.status === 'EL'){
         this.showModalObs = true

       }else{
         Swal.fire({
           position: "top-end",
           icon: "warning",
           title: "Status de movimento não permite alteração",
           showConfirmButton: false,
           timer: 1500
         })
       }
     },

     alteraRota(){
       console.log('alteraRota')
       this.showModalRota = true
     },

     carregarDados(){
       this.updating = true

       this.totalValorLiq = 0
       this.totalDesconto = 0
       this.totalValorBruto = 0
       this.valorFrete = 0

       api.get(`${getBaseUrl()}api/wmsromaneio`, {
         params: { iddata: this.idData }
       }).then((res) => {
         console.log('then axios wmsromaneioEditar')
         console.log(res.data)

         if (!Array.isArray(res.data) || !res.data[0]) {
           Swal.fire({ icon: 'error', title: 'Erro', text: res.data?.error ?? 'Romaneio não encontrado', timer: 2000, showConfirmButton: false })
           this.updating = false
           return
         }

         this.wmsRomaneioData = res.data[0]

         if (this.wmsRomaneioData.chegada) {
           this.wmsRomaneioData.data_fmt = moment(this.wmsRomaneioData.data).format('YYYY-MM-DD')
           this.wmsRomaneioData.data_fmt_2 = moment(this.wmsRomaneioData.data).format('DD/MM/YYYY')

           this.wmsRomaneioData.chegada_fmt = moment(this.wmsRomaneioData.chegada).format('DD/MM/YYYY')
           this.wmsRomaneioData.chegada_fmt_hora = moment(this.wmsRomaneioData.chegada).format('HH:mm')

           this.wmsRomaneioData.saida_fmt = moment(this.wmsRomaneioData.saida).format('DD/MM/YYYY')
           this.wmsRomaneioData.saida_fmt_hora = moment(this.wmsRomaneioData.saida).format('HH:mm')

         }


         this.transpData = res.data[1]
         this.pedidosData = res.data[2]
         this.imprimeSemTravaStatus = !!res.data[13]

         if (this.pedidosData && this.pedidosData.length) {
           this.pedidosData.forEach(pedido => {
             this.totalValorBruto += Number(pedido.valorliq) || 0
             this.totalDesconto += Number(pedido.valordesc) || 0
             this.valorFrete += Number(pedido.valorfrete) || 0
           })
         }

         this.wmsRomaneioData.valorbruto = this.totalValorBruto
         this.wmsRomaneioData.desconto = this.totalDesconto
         this.wmsRomaneioData.frete = this.valorFrete
         this.wmsRomaneioData.valorliq = this.totalValorBruto - this.totalDesconto + this.valorFrete


         this.movPlpLotesData = res.data[3]
         this.movPlpsData = res.data[4]
         this.qtdTotalDocumentos = res.data[8]
         this.qtdTotalVolumes = res.data[9]

         // this.wmsOsVolumesData = res.data[2]
         // console.log('wmsOsVolumesData')
         // console.log(this.wmsOsVolumesData)
         // let totalVols = 0
         // let pesoVols = 0
        /* this.wmsOsVolumesData.forEach((value) => {
           totalVols += value.qtd
           pesoVols += value.peso
         });
         */
        /*Object.keys(this.wmsOsVolumesData).forEach((key) => {
          this.wmsOsVolumesData[key].forEach((value) => {
            totalVols += value.qtd;
            pesoVols += value.peso;
          });
        });*/

        // this.somaQtdVolumes = totalVols
        // this.somaPesoVolumes = pesoVols


        if (res.data[5]){
          this.dtListPesqUsuario = [
            {
              'name': res.data[5].name,
              'id': res.data[5].id
            },
          ]
        }

        if (res.data[6]) {
          this.totalCorreioServ = res.data[6]
        }


         if (res.data[7]){
           this.empresaData = res.data[7]
         }


        this.idData = this.wmsRomaneioData.id
        this.title = `Editar Romaneio (${this.wmsRomaneioData.id}) - Empresa (${this.empresaData.nome}) - CNPJ (${this.empresaData.cnpj})`

         if(this.transpData && this.transpData.servtransp){
           // console.log('pesquisa serviço correios')
           this.movPlpLoteData.servico = this.transpData.servtransp
           this.pesqCorreioServico(this.movPlpLoteData.servico)
         }

         this.updating = false
      })
    },


    salvar(){
      console.log('salvar')
      console.log('salvar_00')
      console.log(this.wmsRomaneioData.data_fmt)

      this.wmsRomaneioData.data = this.wmsRomaneioData.data_fmt !== null && this.wmsRomaneioData.data_fmt !== 'Invalid date' ? this.wmsRomaneioData.data_fmt : null
      this.wmsRomaneioData.chegada = this.wmsRomaneioData.chegada_fmt_hora ?? this.wmsRomaneioData.chegada_fmt_hora
      this.wmsRomaneioData.saida = this.wmsRomaneioData.saida_fmt_hora ?? this.wmsRomaneioData.saida_fmt_hora
      this.wmsRomaneioData.data_fmt_2 = moment(this.wmsRomaneioData.data).format('DD/MM/YYYY')

      this.updating = true

      this.errosValid = []
      api.post(`${getBaseUrl()}api/wmsromaneio`, {
        wmsromaneioData: this.wmsRomaneioData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        // this.wmsRomaneioData = res.data[0]
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        if (this.idData === 0){
          console.log('redirecionar')
          this.wmsRomaneioData = res.data[0]
          this.$router.replace({ path: `/wmsromaneio/editar/${this.wmsRomaneioData.id}` })
          this.idData = this.wmsRomaneioData.id
          this.carregarDados()

        }

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof  erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="wmsRomaneioData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <PageActionBar
              :primary-actions="[
                {
                  label: 'Salvar',
                  icon: 'bx bx-save',
                  variant: 'outline-primary',
                  onClick: salvar,
                  visible: wmsRomaneioData.status === 'EL'
                },
                {
                  label: 'CONFIRMAR',
                  icon: 'mdi mdi-check-circle',
                  variant: 'success',
                  onClick: confirmar,
                  disabled: wmsRomaneioData.status !== 'EL',
                  visible: wmsRomaneioData.status === 'EL' && wmsRomaItensData && wmsRomaItensData.length > 0
                },
                {
                  label: 'Finalizar',
                  icon: 'bx bx-check-circle',
                  variant: 'success',
                  onClick: finalizar,
                  visible: wmsRomaneioData.status === 'EL'
                },
                {
                  label: 'Expedição',
                  icon: 'bx bx-box',
                  variant: 'warning',
                  onClick: expedirRoma,
                  visible: wmsRomaneioData && wmsRomaneioData.id > 0
                }
              ]"
              :secondary-actions="[
                {
                  label: 'Adicionar Pedido',
                  icon: 'bx bx-plus-circle',
                  variant: 'outline-primary',
                  onClick: addPedido,
                  visible: wmsRomaneioData.status === 'EL'
                },
                {
                  label: 'Imprimir Embarque',
                  icon: 'bx bx-printer',
                  variant: 'outline-info',
                  onClick: imprimir,
                  visible: wmsRomaneioData && wmsRomaneioData.id > 0
                },
                {
                  label: 'Sep. Pedido Por Page',
                  icon: 'mdi mdi-printer',
                  variant: 'outline-secondary',
                  onClick: imprimirSepPedPorPage
                },
                {
                  label: 'Sep. Por Pedido',
                  icon: 'mdi mdi-printer',
                  variant: 'outline-secondary',
                  onClick: imprimirSep
                },
                {
                  label: 'Sep. Por Produto',
                  icon: 'mdi mdi-printer',
                  variant: 'outline-secondary',
                  onClick: imprimirSepAgr
                },
                {
                  label: 'Etiquetas Mini-danfe/Orç.',
                  icon: 'mdi mdi-printer',
                  variant: 'outline-secondary',
                  onClick: imprimirEtiquetas
                },
                {
                  label: 'Etiquetas Logística',
                  icon: 'mdi mdi-printer',
                  variant: 'outline-secondary',
                  onClick: () => showModalImprimirEtiqLogistica = true
                },
                {
                  label: 'Danfe (PDF)',
                  icon: 'mdi mdi-printer',
                  variant: 'outline-secondary',
                  onClick: imprimirZipDanfePdf
                },
                {
                  label: 'PLP Correios',
                  icon: 'bx bx-send',
                  variant: 'outline-warning',
                  onClick: plpCorreios
                },
                {
                  label: 'Solicitar coleta',
                  icon: 'bx bxs-truck',
                  variant: 'outline-secondary',
                  onClick: disparaColeta
                },
                {
                  label: 'Consultar coleta',
                  icon: 'bx bxs-truck',
                  variant: 'outline-secondary',
                  onClick: () => { modalColeta = true; retornoSolicitacaoColeta() }
                },
                {
                  label: 'Re-enviar e-mail embarques',
                  icon: 'bx bx-mail-send',
                  variant: 'outline-secondary',
                  onClick: reenvioEmailEmbarque
                },
                {
                  label: 'Anexar comprovante',
                  icon: 'bx bxs-file-doc',
                  variant: 'outline-secondary',
                  onClick: novoAnexo
                },
                {
                  label: 'Baixar comprovante',
                  icon: 'bx bxs-file-doc',
                  variant: 'outline-secondary',
                  onClick: visualizarComprovante
                },
                {
                  label: 'Cancelar',
                  icon: 'bx bx-block',
                  variant: 'outline-danger',
                  onClick: cancelar,
                  visible: wmsRomaneioData.status === 'EL'
                }
              ]"
            />
          </div>
        </div>
      </div>

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-12 col-xl-4">

        <div class="card">
          <div class="card-body">
            <h5>Informações do Romaneio:</h5>
            <div class="d-flex">
              <div class="me-3 d-flex">
                  <div>
                    <p class="mb-2"><strong>Criado em:  </strong> {{ new Date(wmsRomaneioData.created_at).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric'}) }}</p> <!--, hour: '2-digit', minute: '2-digit'-->
                    <p class="mb-2"><strong>Criado por:  </strong> {{ wmsRomaneioData.created_by }}</p>
                  </div>
              </div>
            </div>
            <br>
            <div class="d-flex">
              <div class="me-3 d-flex">
                <div>
                  <p class="mb-2"><strong>Atualizado em:  </strong> {{ new Date(wmsRomaneioData.updated_at).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric'}) }}</p> <!--, hour: '2-digit', minute: '2-digit'-->
                  <p class="mb-2"><strong>Atualizado por:  </strong> {{ wmsRomaneioData.updated_by }}</p>
                </div>
              </div>
            </div>
            <br>
            <div class="d-flex">
              <div class="me-3 d-flex">
                <div>
                  <p class="mb-2"><strong>Empresa: </strong> {{ wmsRomaneioData.empresanome }}</p>
                  <p class="mb-2"><strong>CNPJ: </strong> {{ wmsRomaneioData.empresacnpj }}</p>
                </div>
              </div>
            </div>
            <br>
            <div class="d-flex">
              <div class="me-3 d-flex">
                <div>
                  <p class="mb-2"><strong>E-mail disparado em:  </strong> {{ new Date(wmsRomaneioData.updated_at).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric'}) }}</p> <!--, hour: '2-digit', minute: '2-digit'-->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">

                <span
                    v-if="fornecedorData"
                    class="avatar-title rounded-circle"
                    style="max-height: 55px;
                    min-width: 55px;">{{ formatInteger(wmsRomaItensData.length) }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="text-muted">

                      <a href="javascript: void(0);" @click="showModalDetalhes = true">
                        <h5 class="mb-1 text-info">{{ wmsRomaneioData.data_fmt_2 !== null ? wmsRomaneioData.data_fmt_2 : 'Data' }}</h5>
                      </a>

                      <a href="javascript: void(0);" @click="showModalDetalhes = true">
                        <h5 class="mb-1"> {{ wmsRomaneioData.motorista !== null ? wmsRomaneioData.motorista : 'Motorista' }} </h5>
                        <p class="mb-0">{{ wmsRomaneioData.identidade !== null ? wmsRomaneioData.identidade : 'Identidade' }}</p>
                      </a>

                    </div>
                  </div>

                  <a href="javascript:void(0);" class="ms-2" @click="showModalDetalhes = true" >

                    {{ wmsRomaneioData.placa !== null ? wmsRomaneioData.placa : 'Placa' }}
                    <i class="mdi mdi-arrow-right ms-1"></i>

                  </a>

                </div>
                <hr />
                <div class="row">

                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2" v-if="wmsRomaItensData">Pedidos</p>
                      <h5 class="mb-0">{{ formatInteger(wmsRomaneioData.contos) }}</h5>
                    </div>
                  </div>


                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Chegada</p>
                      <h5 class="mb-0">{{ wmsRomaneioData.chegada_fmt_hora }} </h5>
                    </div>
                  </div>



                  <div class="col-4">
                    <div>
                      <p class="text-muted text-truncate mb-2">Saída</p>
                      <h5 class="mb-0">{{ wmsRomaneioData.saida_fmt_hora }} </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>



        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">

              <a href="javascript: void(0);" v-if="!pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ wmsRomaneioData.tipo }}</h5>
              </a>

              <a href="javascript: void(0);" v-if="pedTipoData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ pedTipoData != null ? pedTipoData.descricao : '' }}</h5>
              </a>

              <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
                <b-dropdown-item href="#">Visualizar Pedido</b-dropdown-item>
                <!--                <b-dropdown-divider></b-dropdown-divider>-->
                <!--                <b-dropdown-item href="#">Nova Chave de Desconto</b-dropdown-item>-->
              </b-dropdown>
            </div>

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" v-if="transpData && transpData.id" @click="selecionaTransp">
                  <p class="text-muted mb-1">{{ transpData.cnpj }}</p>
                  <p class="text-muted mb-1">{{ transpData.nome }}</p>
                </a>

                <a href="javascript: void(0);" v-else @click="selecionaTransp">
                  <h4 class="mb-3">Selecionar transportadora...</h4>

                </a>


                <p class="text-info mb-0">

                  <router-link v-if="wmsRomaneioData.origem === 'compra'"  :to="`/movcompra/editar/${wmsRomaneioData.origem_id}`" target="_blank">
                  <span>{{ nomeOrigem(wmsRomaneioData.origem) }} ({{ wmsRomaneioData.origem_id }})
                    <i class="mdi mdi-arrow-right ms-1"></i>
                    {{ wmsRomaneioData.codigo }}
                    </span>
                  </router-link>


                  <router-link v-if="wmsRomaneioData.origem === 'pedido'"  :to="`/pedido/detalhe/${wmsRomaneioData.origem_id}`" target="_blank">
                  <span>{{ nomeOrigem(wmsRomaneioData.origem) }} ({{ wmsRomaneioData.origem_id }})
                    <i class="mdi mdi-arrow-right ms-1"></i>
                    {{ wmsRomaneioData.codigo }}
                    </span>
                  </router-link>

                </p>
              </div>
              <div class="ms-auto align-self-end">
                <i class="bx bx-detail display-4 text-light"></i>
              </div>
            </div>

            <hr />

            <div class="d-flex flex-wrap">
              <div>
                <a href="javascript: void(0);" @click="alteraObs">
                  <p class="text-warning mb-0">
                      <span>
                        {{ wmsRomaneioData.obs != null ? wmsRomaneioData.obs : 'Observações' }}
                        <i class="mdi mdi-chat-alert ms-1"></i>
                      </span>
                  </p>
                </a>
              </div>

              <div class="ms-auto text-end">
                <a href="javascript: void(0);" @click="alteraRota">
                  <p class="text-info mb-0">
                      <span>
                        {{ wmsRomaneioData.rota != null ? 'Rota: ' + wmsRomaneioData.rota : 'Rota' }}
                        <i class="mdi mdi-map-marker-path ms-1"></i>
                      </span>
                  </p>
                </a>
              </div>

            </div>

          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento de Valores</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td>Valor Total Bruto</td>
                  <td class="float-end">{{ formatDecimal(this.wmsRomaneioData.valorbruto) }}</td>
                </tr>
                <tr>
                  <td>Valor Desconto</td>
                  <td class="float-end"> {{ formatDecimal(this.wmsRomaneioData.desconto) }}</td>
                </tr>
                <tr>
                  <td>Frete</td>
                  <td class="float-end">{{ formatDecimal(this.wmsRomaneioData.frete) }}</td>
                </tr>
                <tr>
                  <th>Valor Total Líquido</th>
                  <th class="float-end">{{ formatDecimal(this.wmsRomaneioData.valorliq) }}</th>
                </tr>
                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-12 col-xl-8">
        <div class="card">
          <div class="card-body">

            <div class="d-flex mb-2">
              <span class=me-2><strong>Itens Selecionados: {{ totalSelecionado }}</strong></span>
              <span class=me-2><strong> | Quantidade total volumes: {{ qtdTotalVolumes }}</strong></span>
              <span class=me-2><strong> | Quantidade total documentos: {{ qtdTotalDocumentos }}</strong></span>
              <span v-if="loadingDisparaColeta"> Loading... (Solicitação de Coleta) </span>
            </div>

            <Loader v-if="loadingDisparaColeta" style="min-height: 400px;">
            </Loader>

            <div v-if="isTagiaHost" class="mb-2">
              <button
                class="btn btn-warning btn-sm"
                :disabled="sincronizando"
                @click="sincronizarEtiquetas()"
              >
                <i class="fa fa-refresh" :class="{ 'fa-spin': sincronizando }"></i>
                {{ sincronizando ? 'Sincronizando...' : 'Sincronizar Etiquetas' }}
              </button>
            </div>

            <div class="table-responsive" v-if="!loadingDisparaColeta">
              <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr class="table-data">
                  <th>

                    <input id="selecionaTodos" type="checkbox" @change="selecionaTodos" v-model="selecionarTodos" ref="selecionaTodos" />

                  </th>
                  <th>ID</th>
                  <th>Origem ID</th>
                  <th>Codigo</th>
                  <th>Origem</th>
                  <th>Código Objeto</th>
<!--                  <th>Mensagem de erro</th>-->
                  <th>Emissão</th>
                  <th class="text-end">Vl.N.F.(R$)</th>
                  <th class="text-end">Qtd. Vols.</th>
                  <th> Volume(s) </th>
                  <th class="text-end">Peso</th>
                  <th class="">Destinatário</th>
                  <th class="">Município / UF</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in pedidosData" :key="data.id" :class="{ 'bg-green' : data.wms_codobj, 'bg-yellow': ! data.wms_codobj}" class="table-data">

                  <td>

                    <input :id="'selec_' + data.id" type="checkbox" v-model="data.selecionado" @click="selecionarItem(data)" />

                  </td>

                  <td>
                    <a href="javascript: void(0);"
                       @click="abrirWmsOs(data.wmsosid)"
                       class="text-body fw-bold  text-wrap">
                      <h5 class="text-muted mb-0">{{ data.wmsosid }} </h5>
                    </a>
                  </td>

                  <td class="">{{ data.id }}</td>
                  <td>{{ data.codigo }}</td>
                  <td>{{ data.origem }}</td>
                  <!--                  <td>-->
                  <!--                      <span class="badge badge-pill badge-soft-success font-size-11"-->
                  <!--                            :class="data.stswms === 'SE' ? 'badge-soft-success' : 'badge-soft-danger' ">-->
                  <!--                        {{ nomeStatusWms(data.stswms)  }}-->
                  <!--                      </span>-->
                  <!--                    <p v-if="data.stsocor === 'A'">-->
                  <!--                      <span class="badge badge-pill badge-soft-success font-size-11 badge-soft-danger">-->
                  <!--                        Ocorrência-->
                  <!--                      </span>-->
                  <!--                    </p>-->
                  <!--                  </td>-->


                  <td class="">{{ data.wms_codobj }}</td>
<!--                  <td class="">{{ data.mensagem_erro }}</td>-->
                  <td class="">{{ formatDate(data.dtemissao) }}</td>
                  <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
                  <td class="text-end">
                    {{ formatInteger(data.contvols) }}
                    <a v-if="data.contvols < 1 && isTagiaHost"
                       href="javascript:void(0);"
                       class="action-icon text-warning ms-1"
                       :title="'Retentar busca de volumes Tagia para NF ' + data.codigo"
                       @click="retryBuscarVolumesTagia(data)">
                      <i class="bx bx-refresh font-size-16"></i>
                    </a>
                  </td>

                  <!--                       @click="showModalVolume = true"-->
                  <td class="text-center">
                    <a href="javascript:void(0);"
                       class="action-icon text-info mx-2"
                       @click="abrirModalVol(data)"
                       title="Identificar Volume(s)">
                      <i class="bx bx-box font-size-18"></i>
                    </a>
                  </td>
                  <td class="text-end">{{ formatDecimal(data.pesobrt) }}</td>
                  <td class="text-wrap" style="max-width: 200px;">
                    {{ data.nome }}
                  </td>
                  <td class="text-wrap"> {{ data.cidade }} / {{ data.estado }} </td>
                  <td class="text-end">


<!--                   FUNÇÃO NO BACKEND NÃO EXISTE (ROGERIO) -->
<!--                    <a href="javascript:void(0);"-->
<!--                                          v-if="wmsRomaneioData.status === 'EL'"-->
<!--                                          class="action-icon text-warning mx-2"-->
<!--                                          @click="desvRomPed(data.wmsos_id)"-->
<!--                                          title="Desvincular nota fiscal do romaneio">-->
<!--                      <i class="bx bx-log-out-circle font-size-18"></i>-->
<!--                    </a>-->
                    <a href="javascript:void(0);"
                       class="action-icon text-warning mx-2"
                       @click="consEnderEntrega(data.destcnpj)"
                       title="Consultar endereço de entrega">
                      <i class="bx bx-search font-size-18"></i>
                    </a>


                    <a href="javascript:void(0);"
                       v-if="wmsRomaneioData.status === 'EL'"
                       class="action-icon text-danger mx-2"
                       @click="deletarRomPed(data.wmsosid)"
                       title="Deletar processo de conferência até o ponto atual">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       class="action-icon text-danger mx-2"
                       @click="imprimirEtiquetaLogistica(null, data.wmsosid)"
                       title="Imprimir etiqueta logística">
                      <i class="bx bxs-printer font-size-18"></i>
                    </a>

                  </td>
                  <td class="text-end">
                    <!--                    <a href="javascript:void(0);"-->
                    <!--                       class="action-icon text-info mx-2"-->
                    <!--                       @click="enderecarProduto(data)">-->
                    <!--                      <i class="mdi mdi-apps-box font-size-18"></i>-->
                    <!--                    </a>-->
                    <!--                    <a href="javascript:void(0);"-->
                    <!--                       v-if="wmsRomaneioData.status === 'EL'"-->
                    <!--                       class="action-icon text-warning mx-2"-->
                    <!--                       @click="editarProduto(data.id)">-->
                    <!--                      <i class="mdi mdi-pencil-outline font-size-18"></i>-->
                    <!--                    </a>-->



                  </td>
                </tr>
                </tbody>
              </table>

<!--              <table class="table align-middle mb-0 table-nowrap" v-else>-->
<!--                <thead class="table-light">-->
<!--                <tr class="table-data">-->
<!--                  <th>-->
<!--                    <input id="selecionaTodos" type="checkbox" @change="selecionaTodos" v-model="selecionarTodos" ref="selecionaTodos" />-->
<!--                  </th>-->
<!--                  <th>Wmsos ID</th>-->
<!--                  <th>Orcto ID</th>-->
<!--                  <th>Código</th>-->
<!--                  <th>Código Objeto</th>-->
<!--                  <th>Emissão</th>-->
<!--                  <th class="text-end">Vl. Orcto(R$)</th>-->
<!--                  <th class="text-end">Qtd. Vols.</th>-->
<!--                  <th> Volume(s) </th>-->
<!--                  <th class="text-end">Peso</th>-->
<!--                  <th class="">Destinatário</th>-->
<!--                  <th class="">Município / UF</th>-->
<!--                  <th class="text-end">Ações</th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->

<!--                <tr v-for="data in pedidosData" :key="data.id" :class="{ 'bg-green' : data.wms_codobj, 'bg-yellow': ! data.wms_codobj}" class="table-data">-->

<!--                  <td>-->

<!--                    <input :id="'selec_' + data.id" type="checkbox" v-model="data.selecionado" @click="selecionarItem(data)" />-->

<!--                  </td>-->

<!--                  <td>-->
<!--                    <a href="javascript: void(0);"-->
<!--                       @click="abrirWmsOs(data.wmsos_id)"-->
<!--                       class="text-body fw-bold  text-wrap">-->
<!--                      <h5 class="text-muted mb-0">{{ data.wmsos_id }} </h5>-->
<!--                    </a>-->
<!--                  </td>-->

<!--                  <td class="">{{ data.id }}</td>-->
<!--                  <td class="">{{ data.numped ?? data.codigo }}</td>-->
<!--                  <td class="">{{ data.wms_codobj }}</td>-->
<!--                  <td class="">{{ formatDate(data.dtemissao) }}</td>-->
<!--                  <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>-->
<!--                  <td class="text-end">{{ formatInteger(data.contvols) }}</td>-->

<!--                  &lt;!&ndash;                       @click="showModalVolume = true"&ndash;&gt;-->
<!--                  <td class="text-center">-->
<!--                    <a href="javascript:void(0);"-->
<!--                       class="action-icon text-info mx-2"-->
<!--                       @click="abrirModalVol(data)"-->
<!--                       title="Identificar Volume(s)">-->
<!--                      <i class="bx bx-box font-size-18"></i>-->
<!--                    </a>-->
<!--                  </td>-->
<!--                  <td class="text-end">{{ formatDecimal(data.pesobrt) }}</td>-->
<!--                  <td class="text-wrap" style="max-width: 200px;">-->
<!--                    {{ data.nome }}-->
<!--                  </td>-->
<!--                  <td class="text-wrap"> {{ data.cidade }} / {{ data.estado }} </td>-->
<!--                  <td class="text-end">-->

<!--                    <a href="javascript:void(0);"-->
<!--                       class="action-icon text-warning mx-2"-->
<!--                       @click="consEnderEntrega(data.destcnpj)"-->
<!--                       title="Consultar endereço de entrega">-->
<!--                      <i class="bx bx-search font-size-18"></i>-->
<!--                    </a>-->


<!--                    <a href="javascript:void(0);"-->
<!--                       v-if="wmsRomaneioData.status === 'EL'"-->
<!--                       class="action-icon text-danger mx-2"-->
<!--                       @click="deletarRomPed(data.wmsos_id)"-->
<!--                       title="Deletar processo de conferência até o ponto atual">-->
<!--                      <i class="mdi mdi-trash-can font-size-18"></i>-->
<!--                    </a>-->

<!--                    <a href="javascript:void(0);"-->
<!--                       class="action-icon text-danger mx-2"-->
<!--                       @click="imprimirEtiquetaLogistica(null, data.wmsosid)"-->
<!--                       title="Imprimir etiqueta logística">-->
<!--                      <i class="bx bxs-printer font-size-18"></i>-->
<!--                    </a>-->

<!--                  </td>-->
<!--                  <td class="text-end">-->
<!--                  </td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
            </div>



          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!updating">
      <div class="col-xl-12">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">

              <b-pagination
                  v-model="currentPage"
                  :total-rows="20"
                  @update:modelValue="onPageChange">
              </b-pagination>

            </ul>
          </div>
        </div>
      </div>
    </div>




    <b-modal title="Alterar Observação" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="observacao">Favor informar as observações</label>
          <textarea
              id="obs"
              v-model="wmsRomaneioData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações"/>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarObs()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal title="Alterar Rota" v-model="showModalRota" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="rota">Favor informar a rota</label>

          <input
              id="rota"
              v-model="wmsRomaneioData.rota"
              type="text"
              class="form-control"
              placeholder="Rota"/>

        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalRota = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarRota()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal :title="isNovoRomaneio ? 'Selecionar Transportadora' : 'Detalhes Transportadora'" v-model="showModalTransp" centered hide-footer :hide-header-close="isNovoRomaneio" :no-close-on-backdrop="isNovoRomaneio" :no-close-on-esc="isNovoRomaneio">
      <div class="col-md-12">
        <div class="mb-3">
          <span>Selecionar Nova Transportadora</span>

          <multiselect id="repres"
                       @search-change="pesqTransp"
                       @select="escolheuTransp"
                       v-model="wmsRomaneioData.transp"
                       placeholder="Pesquisar transportadora"
                       :options="dtListPesqTransp"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="cnpj">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.cnpj }}
                  </span>
                  <span class="mx-4" >

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <span class="mx-4" >
                </span>
                <span class="mx-4" >
                </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingTransp">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingTransp && transpData && !isNovoRomaneio">
        <p class="mb-2">
          Transportadora Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank" >
          <p class="mb-2">
            CNPJ:
            <span class="text-primary"> {{ transpData.cnpj }} </span>
          </p>

          <p class="mb-2" >
            Nome:
            <span class="text-primary"> {{ transpData.nome }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimos Pedidos</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/orcamento/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosCli) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosCli / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5" v-if="isNovoRomaneio">
          <b-button variant="light" @click="$router.push('/wmsromaneios/list')">
            <i class="bx bx-arrow-back font-size-16 align-middle me-2"></i>
            Voltar
          </b-button>
          <b-button type="submit" variant="primary" class="ms-1" :disabled="!wmsRomaneioData.transp" @click="escolheuTransp">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
        <div class="text-end mt-5" v-else>
          <b-button variant="light" @click="showModalTransp = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarTransp">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg" title="Detalhes Romaneio" v-model="showModalDetalhes" centered hide-footer>
      <div class="col-md-12">
        <form class="needs-validation" @submit.prevent="confirmarDetalhes">


          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <label for="motorista">Motorista</label>
                <input
                    id="motorista"
                    v-model="wmsRomaneioData.motorista"
                    type="text"
                    class="form-control"
                    placeholder="Motorista"/>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="identidade">Identidade</label>
                <input
                    id="identidade"
                    v-model="wmsRomaneioData.identidade"
                    type="text"
                    class="form-control"
                    placeholder="Identidade"/>
              </div>
            </div>


            <div class="col-md-6">
              <div class="mb-3">
                <label for="placa">Placa Veículo</label>
                <input
                    id="placa"
                    v-model="wmsRomaneioData.placa"
                    type="text"
                    class="form-control"
                    placeholder="Placa Veículo"/>
              </div>
            </div>


            <div class="col-sm-6">
              <div class="mb-3">
                <label for="tipoveic">Tipo</label>
                <select
                    id="tipoveic"
                    v-model="wmsRomaneioData.tipoveic"
                    class="form-control">
                  <option value="MT">Motocicleta</option>
                  <option value="AT">Automóvel</option>
                </select>

              </div>
            </div>


          </div>

          <div class="row">

            <div class="col-md-6">
              <div class="mb-3">
                <span class="font-size-13">Usuário Logística</span>
                <multiselect id="inputUsuario"
                             @search-change="pesqUsuario"
                             v-model="wmsRomaneioData.user_id"
                             placeholder="pesquisar usuário..."
                             :options="dtListPesqUsuario"
                             :searchable="true"
                             label="name"
                             track-by="name"
                             value-prop="id"
                             class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                    </div>
                    <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.name }}
                              </span>

                      <span class="mx-4" >
                                {{ slotProps.option.tipo }}
                              </span>
                    </div>
                  </template>
                </multiselect>

              </div>
            </div>



          </div>

          <div class="row">

            <div class="col-md-4">
              <div class="mb-3">
                <label for="data">Data</label>
                <input
                    id="data"
                    v-model="wmsRomaneioData.data_fmt"
                    type="date"
                    class="form-control"
                    placeholder="Data"/>
              </div>
            </div>


            <div class="col-md-4">
              <div class="mb-3">
                <label for="chegada">Chegada</label>
                <input
                    id="chegada"
                    v-model="wmsRomaneioData.chegada_fmt_hora"
                    type="time"
                    class="form-control"
                    placeholder="Data"/>
              </div>
            </div>



            <div class="col-md-4">
              <div class="mb-3">
                <label for="saida">Saída</label>
                <input
                    id="saida"
                    v-model="wmsRomaneioData.saida_fmt_hora"
                    type="time"
                    class="form-control"
                    placeholder="Data"/>
              </div>
            </div>


          </div>


        </form>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalDetalhes = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarDetalhes()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Adicionar Pedido" v-model="showModalAddPedido" centered hide-footer @shown="setFocus">
      <div class="col-md-12">
        <div class="d-flex float-end" style="width: 140px; margin-top: -30px; margin-right: -5px">
          <h5 class="font-size-12" v-if="modoPesq === 'chavenf'">Modo de Pesq. Chave NF</h5>
          <h5 class="font-size-12" v-if="modoPesq === 'nf'">Modo de Pesq. Número NF</h5>
          <div class="d-flex align-items-center justify-content-between" style="margin-top: -5px; margin-left: 5px">
            <b-form-checkbox
                switch
                size="md"
                value="nf"
                unchecked-value="chavenf"
                v-model="modoPesq">
            </b-form-checkbox>
          </div>
        </div>

        <div v-if="modoPesq === 'chavenf'" class="mb-3 mt-3">
          <label for="chavenf">Favor informar chave da nota fical</label>
          <input
              id="chavenf"
              ref="chavenfInput"
              v-model="chaveAddNf"
              type="text"
              class="form-control"
              placeholder="Chave da Nota Fiscal"
              @keydown.enter="confirmarAddPedido"
              :class="{'is-invalid': submittedAddPedido && !chaveAddNf,}"/>
          <div
              v-if="submittedAddPedido && !chaveAddNf" class="invalid-feedback">
                <span>
                  Campo obrigatório, favor preencher.
                </span>
          </div>
        </div>

        <div v-if="modoPesq === 'nf'" class="mb-3 mt-3">
          <label for="nf">Favor informar número da nota fical</label>
          <input
              id="nf"
              ref="nfInput"
              v-model="chaveAddNf"
              type="text"
              class="form-control"
              placeholder="Número da Nota Fiscal"
              @keydown.enter="confirmarAddPedido"
              :class="{'is-invalid': submittedAddPedido && !chaveAddNf,}"/>
          <div
              v-if="submittedAddPedido && !chaveAddNf" class="invalid-feedback">
                <span>
                  Campo obrigatório, favor preencher.
                </span>
          </div>
        </div>


        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalAddPedido = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confirmarAddPedido()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>
      </div>
    </b-modal>

    <b-modal title="Adicionar Pedido" v-model="showModalAddPedidoOrcto" centered hide-footer @shown="setFocus">
      <div class="col-md-12">
        <div class="d-flex float-end" style="width: 140px; margin-top: -30px; margin-right: -5px">
          <h5 class="font-size-12" v-if="modoPesqOrcto === 'orcto_id'">Modo de Pesq. ID Orçamento</h5>
          <h5 class="font-size-12" v-if="modoPesqOrcto === 'orcto_cod'">Modo de Pesq. Código Orçamento</h5>
          <div class="d-flex align-items-center justify-content-between" style="margin-top: -5px; margin-left: 5px">
            <b-form-checkbox
                switch
                size="md"
                value="orcto_cod"
                unchecked-value="orcto_id"
                v-model="modoPesqOrcto">
            </b-form-checkbox>
          </div>
        </div>

        <div v-if="modoPesqOrcto === 'orcto_id'" class="mb-3 mt-3">
          <label for="orcto_id">Favor informar ID do orçamento</label>
          <input
              id="orcto_id"
              ref="orcto_id"
              v-model="orcto_ref"
              type="text"
              class="form-control"
              placeholder="Id do orçamento"
              @keydown.enter="confirmarAddPedidoOrcamento"
              :class="{'is-invalid': submittedAddPedidoOrcto && !orcamento_id}"/>
          <div
              v-if="submittedAddPedidoOrcto && !orcamento_id" class="invalid-feedback">
                <span>
                  Campo obrigatório, favor preencher.
                </span>
          </div>
        </div>

        <div v-if="modoPesqOrcto === 'orcto_cod'" class="mb-3 mt-3">
          <label for="orcto_cod">Favor informar o código do orçamento</label>
          <input
              id="orcto_cod"
              ref="orcto_cod"
              v-model="orcto_ref"
              type="text"
              class="form-control"
              placeholder="Código do orçamento"
              @keydown.enter="confirmarAddPedidoOrcamento"
              :class="{'is-invalid': submittedAddPedidoOrcto && !orcamento_codigo}"/>
          <div
              v-if="submittedAddPedidoOrcto && !orcamento_codigo" class="invalid-feedback">
                <span>
                  Campo obrigatório, favor preencher.
                </span>
          </div>
        </div>


        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalAddPedidoOrcto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confirmarAddPedidoOrcamento()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>
      </div>
    </b-modal>


    <b-modal size="xl" title="PLP Correios (Lote)" v-model="showModalPLPCorreios" centered hide-footer>


      <div class="card-body">


        <div v-if="exibirNovaPlp === true && loadingMovPlp === false">

          <div>
            <div class="col-md-12">
              <div class="mb-3">
                <label for="modalPLPCorreios">Criar Nova PLP para Pedidos: <span class="text-black-50">{{ numerosPedidosSelecionados }}</span></label>

              </div>
            </div>



            <div class="row">

              <div class="col-sm-3">
                <div class="mb-3">
                  <label for="formato">Formato Objeto</label>
                  <select
                      id="formato"
                      v-model="movPlpLoteData.formato"
                      class="form-control"
                      :class="{'is-invalid': submittedMovPlpLote && !movPlpLoteData.formato}">
                    <option value=1>Envelope</option>
                    <option value=2>Caixa / Pacote</option>
                    <option value=3>Rolo / Cilindro</option>
                  </select>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.formato" class="invalid-feedback">
                    <span>Campo formato obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>





              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="layprint">Layout Impressão</label>
                  <select
                      id="layprint"
                      v-model="movPlpLoteData.layprint"
                      class="form-control">
<!--                    <option value=PADRAO>PADRAO</option>-->
                    <option value=LINEAR_100_150>LINEAR_100_150</option>
                    <option value=LINEAR_100_80>LINEAR_100_80</option>
                    <option value=LINEAR_A4>LINEAR_A4</option>
                    <option value=LINEAR_A>LINEAR_A</option>
                  </select>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.formato" class="invalid-feedback">
                    <span>Campo formato obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>



              <div class="col-md-6">
                <div class="mb-3">
                  <span>Serviço</span>

                  <multiselect id="segtofrete"
                               class="mt-2"
                               @search-change="pesqCorreioServico"
                               v-model="movPlpLoteData.servico"
                               placeholder="Pesquisar serviços"
                               :options="dtListPesqCorreioServico"
                               :searchable="true"
                               label="descricao"
                               track-by="descricao"
                               :style="submittedMovPlpLote && !movPlpLoteData.servico ? 'border: 1px solid #f86c6b !important;' : ''"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                          <span class="mx-4" >
                          </span>
                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                        <span class="mx-4"></span>
                        <span class="mx-4"></span>
                        <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                      </div>
                    </template>
                  </multiselect>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.servico">
                    <span class="text-danger font-size-11">Campo Serviço obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>




            </div>


            <div class="row">


              <div class="col-md-3">
                <label for="pesoinf">Peso (GR)</label>
                <div class="position-relative">
                  <input
                      id="pesoinf"
                      type="number"
                      v-model="movPlpLoteData.pesoinf"
                      class="form-control text-end"
                      placeholder="Peso informado"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlpLote && !movPlpLoteData.pesoinf}"/>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.pesoinf" class="invalid-feedback">
                    <span>Campo peso obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>


              <div class="col-md-2">
                <label for="compinf">Comprimento (CM)</label>
                <div class="position-relative">
                  <input
                      id="compinf"
                      type="number"
                      v-model="movPlpLoteData.compinf"
                      class="form-control text-end"
                      placeholder="Comprimento informado"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlpLote && !movPlpLoteData.compinf}"/>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.compinf" class="invalid-feedback">
                    <span>Campo comprimento obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>



              <div class="col-md-2">
                <label for="altuinf">Altura (CM)</label>
                <div class="position-relative">
                  <input
                      id="altuinf"
                      type="number"
                      v-model="movPlpLoteData.altuinf"
                      class="form-control text-end"
                      placeholder="Altura informada"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlpLote && !movPlpLoteData.altuinf}"/>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.altuinf" class="invalid-feedback">
                    <span>Campo altura obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label for="larginf">Largura (CM)</label>
                <div class="position-relative">
                  <input
                      id="larginf"
                      type="number"
                      v-model="movPlpLoteData.larginf"
                      class="form-control text-end"
                      placeholder="Largura informada"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlpLote && !movPlpLoteData.larginf}"/>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.larginf" class="invalid-feedback">
                    <span>Campo largura obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>



              <div class="col-md-2">
                <label for="prevpost">Previsão Postagem</label>
                <div class="position-relative">
                  <input
                      id="prevpost"
                      type="date"
                      v-model="movPlpLoteData.prevpost"
                      class="form-control text-end"
                      placeholder="Previsão Postagem"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlpLote && !movPlpLoteData.larginf}"/>
                  <div v-if="submittedMovPlpLote && !movPlpLoteData.larginf" class="invalid-feedback">
                    <span>Campo previsão postagem obrigatório, favor preencher.</span>
                  </div>


                </div>
              </div>


            </div>
          </div>

        </div>


        <div class="row" v-if="loadingMovPlp">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>



        <div class="table-responsive mt-5" v-if="movPlpLotesData && !loadingMovPlp">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">ID Lote</th>
              <th scope="col" class="">Mensagem</th>
              <th scope="col" class="text-end">Peso</th>
              <th scope="col">Status</th>
              <th scope="col">Pr.Postagem</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in movPlpLotesData" :key="data.id">
              <td>
                {{ data.id}}
              </td>

              <td>
                {{ data.idlote }}
              </td>
              <td>
                {{ data.mensagem }}
              </td>

              <td class="text-end">
                {{ formatDecimal(data.pesoinf) }}
              </td>
              <!--              <td>-->
              <!--                -->
              <!--                -->
              <!--                {{ data.descstatus }}-->
              <!--              </td>-->

              <td>
                <span
                    class="badge badge-pill badge-soft-success font-size-11"
                    :class="data.status === 'COMPLETED' ? 'badge-soft-success' : 'badge-soft-warning'">
                  {{ data.status  }}
                </span>
              </td>

              <td>
                {{ formatDate(data.prevpost) }}
              </td>
              <td class="text-end">
                {{ formatDateTime(data.created_at) }}
              </td>

              <td class="text-end">


                <a href="javascript:void(0);"
                   v-if=" movPlpsData && movPlpsData.length > 0 && movPlpsData[0].descstatus === 'Postado'"
                   class="action-icon text-info mx-2"
                   title="Consultar Status Lote"
                   style="pointer-events: none; opacity: 0.3; cursor: not-allowed"
                   @click="consPLPLoteCorreios(data.idlote)">
                  <i class="mdi mdi-book-search font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   class="action-icon text-info mx-2"
                   title="Consultar Status Lote"
                   @click="consPLPLoteCorreios(data.idlote)">
                  <i class="mdi mdi-book-search font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   v-if="movPlpsData && movPlpsData.length > 0  && movPlpsData[0].descstatus === 'Postado'"
                   class="action-icon text-success mx-2"
                   title="Objeto já Postado."
                   style="opacity: 0.7;"
                   @click="solicitarRotuloLote(data.idlote)">
                  <i class="mdi mdi-printer font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   v-if="movPlpsData && movPlpsData.length > 0  && movPlpsData[0].descstatus === 'Cancelado'"
                   class="action-icon text-danger mx-2"
                   title="Solicitação de Rótulo Cancelada"
                   style="opacity: 0.7;"
                   @click="solicitarRotuloLote(data.idlote)">
                  <i class="mdi mdi-printer font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   v-else-if="movPlpsData && movPlpsData.length > 0  && (movPlpsData[0].descstatus === 'COMPLETED' || movPlpsData[0].descstatus === 'STARTED')"
                   class="action-icon text-warning mx-2"
                   title="Solicitação de Rótulo"
                   style="pointer-events: none; opacity: 0.3; cursor: not-allowed"
                   @click="solicitarRotuloLote(data.idlote)">
                  <i class="mdi mdi-printer font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   v-else
                   class="action-icon text-warning mx-2"
                   title="Solicitar Rótulo"
                   @click="solicitarRotuloLote(data.idlote)">
                  <i class="mdi mdi-printer font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                  class="action-icon text-info mx-2"
                  title="Reenviar Pre-postagem"
                  v-if="this.movPlperro || data.erro"
                  @click="confPLPLoteCorreios(data)"
                  >
                  <i class="mdi mdi-repeat font-size-18"></i>
                </a>

<!--                <a href="javascript:void(0);"
                   class="action-icon text-info mx-2"
                   title="Reprocessar PLP"
                   @click="consPLPLoteCorreios(data.idlote)">
                  <i class="mdi mdi-reload font-size-18"></i>
                </a>-->

                <!--                <a href="javascript:void(0);"
                                   v-if="data.status === 'STARTED'"
                                   class="action-icon text-info mx-2"
                                   title="Consultar Status Lote"
                                   @click="consPLPLoteCorreios(data.idlote)">
                                  <i class="mdi mdi-book-search font-size-18"></i>
                                </a>
                                <a href="javascript:void(0);"
                                   v-if="data.status === 'COMPLETED'"
                                   class="action-icon text-info mx-2"
                                   title="Consultar Status Lote"
                                   style="pointer-events: none; opacity: 0.3; cursor: not-allowed">
                                  <i class="mdi mdi-book-search font-size-18"></i>
                                </a>

                                <a href="javascript:void(0);"
                                   v-if="data.status === 'COMPLETED'"
                                   class="action-icon text-warning mx-2"
                                   title="Consultar Todos Objetos"
                                   @click="consultarTodosObjetos(data.idlote)">
                                  <i class="mdi mdi-account-search font-size-18"></i>
                                </a>

                                <a href="javascript:void(0);"
                                   v-if="data.status === 'COMPLETED'"
                                   class="action-icon text-success mx-2"
                                   title="Solicitar Rótulos para Lote"
                                   @click="solicitarRotuloLote(data.idlote)">
                                  <i class="mdi mdi-printer-check font-size-18"></i>
                                </a>-->


              </td>
            </tr>
            </tbody>
          </table>
        </div>


        <div class="table-responsive mt-5" v-if="movPlpsData && !loadingMovPlp">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Pedido</th>
              <th scope="col">Volume</th>
              <th scope="col">ID PLP / Recibo</th>
              <th scope="col">ID Lote</th>
              <th scope="col" class="">Objeto</th>
              <th scope="col" class="text-end">Peso</th>
              <th scope="col">Status</th>

              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in movPlpsData" :key="data.id">
              <td>
                {{ data.id}}
              </td>
              <td>
                {{ data.origem_id}}
              </td>
              <td>
                {{data.qtd + 1 + '/' + data.qtdtotal}}
              </td>
              <td>
                {{ data.correiosid }}
                <p>
                {{ data.recibo }}
                </p>
              </td>
              <td>
                {{ data.lote }}
              </td>

              <td>

                <a href="javascript:void(0);"
                   v-if="data.correiosid && data.status !== '5'"
                   class="action-icon text-info mx-2"
                   :title="!data.codobj ? 'Consultar Objeto' : 'Rastrear Objeto'"
                   @click="consultarObjeto(data)">
                  <i v-if="!data.codobj"
                     class="mdi mdi-box-shadow font-size-18">
                    Consultar
                  </i>

                  <i v-else
                     class="mdi mdi-box-shadow font-size-18">
                    {{ data.codobj }}
                  </i>
                </a>

              </td>

              <td class="text-end">
                {{ formatDecimal(data.pesoinf) }}
              </td>

              <td>
                <span
                    class="badge badge-pill badge-soft-success font-size-11 text-wrap"
                    :class="data.status === '5' ? 'badge-soft-danger' : 'badge-soft-success'">
                  {{ data.descstatus  }}
                </span>
              </td>

              <td class="text-end text-wrap">
                {{ formatDateTime(data.created_at) }}
              </td>

              <td class="text-end">

<!--                <a href="javascript:void(0);"
                   v-if="data.descstatus !== 'STARTED' && data.descstatus !== 'Cancelado'"
                   class="action-icon text-warning mx-2"
                   title="Solicitar Rótulo"
                   @click="solicitarRotulo(data)">
                  <i class="mdi mdi-printer font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   v-if="data.descstatus !== 'STARTED' && data.descstatus !== 'Cancelado'"
                   class="action-icon text-danger mx-2"
                   title="Cancelar PLP"
                   @click="cancelarMovPlp(data.id)">
                  <i class="mdi mdi-trash-can font-size-18"></i>
                </a>-->

                <a href="javascript:void(0);"
                   v-if="data.descstatus === 'Postado' && data.descstatus === 'COMPLETED'"
                   class="action-icon text-danger mx-2"
                   title="Cancelar PLP"
                   style="pointer-events: none; opacity: 0.3; cursor: not-allowed"
                   @click="cancelarMovPlp(data.id)">
                  <i class="mdi mdi-trash-can font-size-18"></i>
                </a>
                <a href="javascript:void(0);"
                   v-else-if="data.descstatus !== 'Cancelado'"
                   class="action-icon text-danger mx-2"
                   title="Cancelar PLP"
                   @click="cancelarMovPlp(data.id)">
                  <i class="mdi mdi-trash-can font-size-18"></i>
                </a>

              </td>
            </tr>
            </tbody>
          </table>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPLPCorreios = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

<!--          <b-button type="submit" variant="outline-info" class="ms-1" @click="consPLPLoteCorreios" v-if="exibirNovaPlp">-->
<!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
<!--            Consultar Status Lote PLP-->
<!--          </b-button>-->

          <b-button type="submit" variant="success" class="ms-1" @click="confPLPLoteCorreios(null)" v-if="exibirNovaPlp">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Criar Nova PLP
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg"
             :title="'Endereço de Entrega Cliente (' + clienteData.codigo + ')' " v-model="showModalEnderEntrega" centered hide-footer>
      <div class="col-md-12">


        <div class="row" v-if="loadingCliente">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>


        <form class="needs-validation" v-if="!loadingDadosCep" @submit.prevent="confirmarEnderEntrega">

          <div class="row" v-if="!loadingCliente">

            <div class="col-sm-4">
              <label for="cep">CEP</label>
              <div class="position-relative">
                <input
                    id="cep"
                    v-maska="'##.###-###'"
                    type="text"
                    v-model="clienteData.cep"
                    class="form-control"
                    placeholder="CEP"
                    :class="{'is-invalid': submittedEnderEntrega && !clienteData.cep}"/>
                <div v-if="submittedEnderEntrega && !clienteData.cep" class="invalid-feedback">
                  <span>Campo CEP obrigatório, favor preencher.</span>
                </div>
                <div class="chat-input-links" v-if="clienteData.cep">
                  <ul class="list-inline mb-0">
                    <li class="list-inline-item">
                      <a
                          @click="consultarCEP"
                          href="javascript: void(0);"
                          v-b-tooltip.hover
                          placement="top"
                          title="Consultar CEP">
                        <i class="mdi mdi-cloud-search-outline text-info"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="rua">Logradouro</label>
                <input
                    id="rua"
                    v-model="clienteData.rua"
                    type="text"
                    class="form-control"
                    placeholder="Logradouro"
                    :class="{'is-invalid': submittedEnderEntrega && !clienteData.rua}"/>
                <div v-if="submittedEnderEntrega && !clienteData.rua"
                     class="invalid-feedback">
                  <span>Campo logradouro obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="numero">Número</label>
                <input
                    id="numero"
                    v-model="clienteData.numero"
                    type="text"
                    class="form-control"
                    placeholder="Número"
                    :class="{'is-invalid': submittedEnderEntrega && !clienteData.numero}"/>
                <div v-if="submittedEnderEntrega && !clienteData.numero"
                     class="invalid-feedback">
                  <span>Campo número obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="compl">Complemento</label>
                <input
                    id="compl"
                    v-model="clienteData.compl"
                    type="text"
                    maxlength="60"
                    class="form-control"
                    placeholder="Complemento"/>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="bairro">Bairro</label>
                <input
                    id="bairro"
                    v-model="clienteData.bairro"
                    type="text"
                    class="form-control"
                    placeholder="Bairro"
                    :class="{'is-invalid': submittedEnderEntrega && !clienteData.bairro}"/>
                <div v-if="submittedEnderEntrega && !clienteData.bairro"
                     class="invalid-feedback">
                  <span>Campo bairro obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="codmun">Código Cidade</label>
                <input
                    id="codmun"
                    v-model="clienteData.codmun"
                    type="text"
                    class="form-control"
                    :disabled="true"
                    placeholder="Código cidade"/>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">

                <span class="font-size-13">Cidade </span>
                <multiselect id="inputCidade"
                             @search-change="pesqCidade"
                             @select="escolheuCidade"
                             v-model="clienteData.codmun"
                             placeholder="Selecionar cidade"
                             :options="dtListPesqCidade"
                             :searchable="true"
                             label="descricao"
                             track-by="descricao"
                             :style="submittedEnderEntrega && !clienteData.codmun ? 'border: 1px solid #f86c6b !important;' : ''"
                             value-prop="codigo"
                             class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 25%;">
                              <span class="text-info">
                                {{ slotProps.option.estado }}
                              </span>
                    </div>
                    <div style="min-width: 300px;">
                              <span class="mx-4" >
                                {{ slotProps.option.descricao }}
                              </span>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submittedEnderEntrega && !clienteData.codmun">
                  <span class="text-danger font-size-11">Campo cidade obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="estado">Estado</label>
                <input
                    id="estado"
                    v-model="clienteData.estado"
                    type="text"
                    class="form-control"
                    placeholder="Estado"/>
              </div>
            </div>

            <div class="col-sm-4">
              <div class="mb-3">
                <label for="refer">Ponto de Referência</label>
                <input
                    id="refer"
                    v-model="clienteData.refer"
                    type="text"
                    class="form-control"
                    placeholder="Ponto de Referência"/>
              </div>
            </div>

          </div>
        </form>

        <div v-if="!loadingDadosCep">
          <ul class="list-inline mb-0">
            <li class="list-inline-item">
              <a
                  @click="buscaCEP"
                  href="javascript: void(0);"
                  v-b-tooltip.hover
                  placement="top"
                  title="Busca Cep"
                  style="top: 30px">
                <i class="mdi mdi-cloud-search-outline text-info"></i>
                Busca Cep (Campos obrigatórios: UF, Cidade, Logradouro)
              </a>
            </li>
          </ul>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalEnderEntrega = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarEnderEntrega()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg" title="Consultar CEP" v-model="showModalConsCEP" hide-footer>

      <div class="row" v-if="loadingDadosCep">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingDadosCep">
        <h5 class="card-title">Favor selecionar os campos que deseja importar</h5>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Endereço</span>
              <b-form-checkbox v-model="consCnpjImpEndereco" switch>
                {{ consCnpjEndereco }}
              </b-form-checkbox>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Complemento</span>
              <b-form-checkbox v-model="consCnpjImpCompl" switch>
                {{ consCnpjCompl }}
              </b-form-checkbox>
            </div>
          </div>

        </div>


        <div class="row">

          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Bairro</span>
              <b-form-checkbox v-model="consCnpjImpBairro" switch>
                {{ consCnpjBairro }}
              </b-form-checkbox>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="mt-4 mt-sm-0">
              <span>Cidade</span>
              <b-form-checkbox v-model="consCnpjImpCidade" switch>
                {{ consCnpjCidade }}
              </b-form-checkbox>
            </div>
          </div>

        </div>


        <div v-if="!loadingDadosCep && clienteData">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalConsCEP = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="confirmarImpCep">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>

      </div>

    </b-modal>

    <b-modal v-model="modalColeta" id="modal-xl" size="xl" title="Retorno de Solicitação de Coleta" title-class="font-18" hide-footer >
      <div class="">
        <div class="row">

          <div class="d-flex justify-content-center">
            <b-button
                variant="outline-success"
                class="mx-2 mb-3"
                @click="SolicitacaoColetaexportExcel">
              <i class="bx bxs-download font-size-16 align-middle me-2"></i>
              Download Excel
            </b-button>
          </div>

          <table class="table-bordered">
            <thead>
            <tr class="table-striped">
              <th>NF-e</th>
              <th>Identificador coleta</th>
              <th>Código coleta</th>
              <th>Status</th>
              <th>Data Solicitação</th>
              <th>Solicitante</th>
              <th>Ações</th>
            </tr>
            </thead>
            <tbody v-if="listaSolicitacaoColeta && listaSolicitacaoColeta.length > 0">
            <template v-for="item in listaSolicitacaoColeta" :key="item.id">
              <tr :class="{'bg-red': !item.cod_coleta}">
                <td>{{ item.nf ?? "não gerado" }}</td>
                <td>{{ item.id_coleta ?? "não gerado" }}</td>
                <td>{{ item.cod_coleta ?? "não gerado" }}</td>
                <td>{{ item.status ?? "não gerado" }}</td>
                <td>{{ formatarData(item.data_solicitacao) }}</td>
                <td>{{ item.solicitante ?? "não gerado" }}</td>
                <td>
                  <button v-if="!item.cod_coleta" class="btn btn-warning btn-md btn-label" title="Gerar uma nova solicitação individual" @click="dispararColetaIndividual(item.nf)">
                    <i class="bx bx-error label-icon"></i>
                    Nova solicitação!
                  </button>
                </td>
              </tr>

              <!-- Subtabela de Volumes -->
              <tr v-if="item.volumes && item.volumes.length > 0">
                <h6 class="align-items-center">{{item.id_coleta}}</h6>
                <td colspan="7">
                  <table class="table-bordered">
                    <thead>
                    <tr class="table-striped">
                      <th>Volume</th>
                      <th>BillCode</th>
                      <th>Identificador</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="volume in item.volumes" :key="volume.id">
                      <td>{{ volume.wmsosvolumeetiq }}</td>
                      <td>{{ volume.txlogisticId }}</td>
                      <td>{{ volume.billcode }}</td>
                    </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </template>
            </tbody>
            <tbody v-else>
            <tr>
              <td colspan="7">Solicitação não realizada</td>
            </tr>
            </tbody>
          </table>


        </div>
      </div>
    </b-modal>

    <b-modal title="Etiquetas logísticas" v-model="showModalImprimirEtiqLogistica" centered hide-footer>
      <div class="col-md-20">
        <h6 class="text-muted">Etiquetas logísticas são impressas individualmente!</h6>
        <div class="mb-3">
          <label for="chavenf">Favor informar uma chave de NF-e por vez!</label>
          <input
              id="chavenf"
              v-model="chaveAddNf"
              type="text"
              class="form-control"
              placeholder="Chave nota fiscal"
              @keydown.enter="imprimirEtiquetaLogistica(chaveAddNf, null)"
              :class="{'is-invalid': submittedAddPedido && !chaveAddNf,}"
              ref="findEtiqLogistica"/>
          <div
              v-if="submittedAddPedido && !chaveAddNf" class="invalid-feedback">
                <span>
                  Campo obrigatório, favor preencher.
                </span>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal title="Etiqueta Logística"
             v-model="showModalEtiquetaLogistica" centered hide-footer
             @hide="focusFindEtiqLogistica">
      <div class="col-md-12">
        <iframe :src="pdfUrl" width="100%" height="500px" style="border:none;"></iframe>
      </div>
    </b-modal>

    <b-modal size="lg" @shown="$refs.qtdvolume.focus()" title="Identificar Volume(s)" v-model="showModalVolume" centered
             hide-footer>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="quantidade">Quantidade</label>
            <input id="qtdvolume" ref="qtdvolume" v-model="wmsOsVolumeData.qtd" type="number"
                   class="form-control text-end" @keypress.enter="informouQtdVolume" placeholder="Enter para confirmar..." />
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="pesovolume">Peso</label>
            <input id="pesovolume" ref="pesovolume" v-model="wmsOsVolumeData.peso" type="number"
                   class="form-control text-end" @keypress.enter="informouPeso" placeholder="Enter para confirmar..." />
          </div>
        </div>

      </div>


      <div class="row" v-if="loadingWmsVolume">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>



      <div class="table-responsive" v-if="wmsOsVolumesData">
        <table class="table table-centered table-nowrap">
          <thead>
          <tr>

            <th scope="col" class="">Etiqueta</th>
            <th scope="col" class="text-end">Peso</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="data in wmsOsVolumesData" :key="data.wmsos_id">
            <td class="text-info">
              <a href="javascript:void(0);" @click="imprimirEtiqueta(data.id)">
                <i class="mdi mdi-printer"></i>
                {{ data.etiqueta }}
              </a>
            </td>


            <td class="text-end">{{ formatDecimal(data.peso) }}</td>
          </tr>

          <tr>
            <td colspan="2">
              <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>
            </td>
            <td class="text-end"> {{ formatDecimal(somaQtdVolumes) }}</td>
          </tr>

          <tr>
            <td colspan="2">
              <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>
            </td>
            <td class="font-size-14 text-end"> {{ formatDecimal(somaPesoVolumes) }}</td>
          </tr>

          </tbody>
        </table>
      </div>




      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalVolume = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <!--          <b-button type="submit" variant="success" class="ms-1"-->
        <!--                    :disabled="this.wmsOsItemSepData.disp <= 0 || wmsOsItemSepData.qtd === 0 || wmsOsItemSepData.qtd > this.wmsOsItemSepData.disp || !wmsOsItemSepData.palete"-->
        <!--                    @click="confirmarSeparacao">-->
        <!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
        <!--            Confirmar-->
        <!--          </b-button>-->

        <b-button type="submit" variant="outline-danger" class="ms-1" v-if="wmsOsVolumesData.length > 0"
                  @click="excluirEtiquetas">
          <i class="bx bxs-trash font-size-16 align-middle me-2"></i>
          Excluir Etiquetas
        </b-button>



        <b-button type="submit" variant="success" class="ms-1"
                  :disabled="!this.wmsOsVolumeData.qtd || this.wmsOsVolumeData.qtd <= 0 || !this.wmsOsVolumeData.peso || this.wmsOsVolumeData.peso <= 0"
                  @click="confirmarVolume">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar Novo Volume
        </b-button>

      </div>
    </b-modal>

    <b-modal title="Criar Novo Anexo (Comprovante)" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile"/>
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"/>
              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal title="Adicionar Pedido por WmsOs" v-model="showModalAddWmsOs" centered hide-footer @shown="setFocus">
      <div class="col-md-12">
        <div class="mb-3 mt-3">
          <label for="chaveAddNf">Favor informar ID da WmsOs</label>
          <input
              id="idWmsOs"
              ref="idWmsOsInput"
              v-model="chaveAddNf"
              type="text"
              class="form-control"
              placeholder="ID WmsOs"
              @keydown.enter="confirmarAddPedido"
              :class="{'is-invalid': submittedAddWmsOs && !idWmsOs}"/>
          <div
              v-if="submittedAddWmsOs && !idWmsOs" class="invalid-feedback">
                <span>
                  Campo obrigatório, favor preencher.
                </span>
          </div>
        </div>


        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalAddWmsOs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confirmarAddPedido()">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>

        </div>
      </div>
    </b-modal>

    <b-modal title="Selecionar tipo documento para importação"
             size="md"
             v-model="showModalAddPedidoTipo"
             centered hide-footer>
      <div class="col-md-12">

        <div class="mb-3">
          <b-form-select v-model="tipoPedidoInput">
            <b-form-select-option :value="null" variant="outline" disabled>Selecione origem do pedido</b-form-select-option>
            <b-form-select-option v-for="list in tipoPedidoList" :key="list.id" :value="list.value" >
              {{ list.text }}
            </b-form-select-option>
          </b-form-select>
        </div>

        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalAddPedidoTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="abrirModalTipoInput">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>

  </Layout>
</template>



<style>
.multiselect-size {
  --ms-max-height: 500px;
}

.bg-green{
  background-color: #ddead1;
}

.bg-yellow{
  background-color: #f7f5bc;
}

.bg-red{
  background-color: #ffcbd1;
}

.table-data{
  //border-color: #454444;
  //border-width: 1px;
  border : 3px solid white;
}
</style>

